export const uz = {
  // Nav/chrome
  'nav.catalog': 'Katalog',
  'nav.tender': 'Tender',
  'nav.login': 'Kirish',
  'nav.dashboard': 'Boshqaruv paneli',
  'nav.signOut': 'Chiqish',
  // Landing
  'landing.hero.title': 'Biznes imkoniyatlarini toping',
  'landing.hero.description':
    "Mamlakat bo'ylab davlat tenderlarini ko'rib chiqing. Hudud, toifa va holat bo'yicha filtrlang.",
  'landing.hero.browseCatalog': "Katalogni ko'rib chiqish",
  'landing.recentTenders': 'Oxirgi tenderlar',
  // Catalog
  'catalog.title': 'Tenderlar katalogi',
  'catalog.loading': 'Tenderlar yuklanmoqda…',
  'error.title': "Yuklab bo'lmadi. Aloqani tekshiring.",
  'error.retry': 'Qayta urinish',
  'error.searchBusy':
    "Hozir saytda bir vaqtda juda ko'p qidiruv bo'lyapti. Sayt ishlayapti: bir necha soniyadan keyin qayta urinib ko'ring.",
  'error.searchTooMany':
    "Oldingi qidiruvlaringiz hali bajarilmoqda. Natijani kuting va qayta urinib ko'ring.",
  'catalog.slowLoad':
    'Qidiruv odatdagidan uzoqroq davom etmoqda. Sayt ishlayapti, natijalar bir necha soniyada chiqadi.',
  'catalog.filters': 'Filtrlar',
  'catalog.filters.a11yDesc': 'Tender katalogi filtrlari.',
  'catalog.filtersApply': "Natijalarni ko'rsatish",
  'catalog.export': 'Excelga eksport',
  'catalog.exportProOnly': 'Eksport Pro tarifida',
  'catalog.exportFailed': "Yuklab bo'lmadi. Qayta urinib ko'ring.",
  'catalog.found': '{{count}} ta tender topildi',
  'catalog.ikpuLabel': 'Tovar kodi',
  'catalog.ikpuAll': 'Barcha toifalar',
  'catalog.sortLabel': 'Saralash',
  'catalog.sort.newest': 'Avval yangilari',
  'catalog.sort.deadline': 'Muddati yaqinlari',
  'catalog.sort.budgetDesc': "Byudjet: kamayish bo'yicha",
  'catalog.sort.budgetAsc': "Byudjet: o'sish bo'yicha",
  'catalog.budgetFrom': 'Eng kam byudjet ({{currency}})',
  'catalog.budgetTo': "Eng ko'p byudjet ({{currency}})",
  'catalog.deadlineFrom': 'Muddat (boshlanishi)',
  'catalog.excludeWords': "Shu so'zlar bor tenderlarni ko'rsatmaslik",
  'catalog.excludeWordsPlaceholder': 'vergul bilan ajrating',
  'catalog.deadlineTo': 'Muddat (tugashi)',
  'catalog.clearFilters': 'Filtrlarni tozalash',
  'catalog.moreFilters': "Ko'proq filtrlar",
  // Tender detail
  'tender.backToIfi': '← XMI loyihalariga qaytish',
  'tender.backToCatalog': '← Katalogga qaytish',
  'tender.loading': 'Tender yuklanmoqda…',
  'tender.sourceLangNote': 'manba tilida',
  'tender.scanNotice':
    'Hujjat skanidan aniqlangan. Summalar, muddatlar, manzillar va rekvizitlarni {{original}} bilan solishtiring.',
  'tender.scanNoticeOriginal': 'asl nusxa',
  // ⚠️ Faqat aniq 404 uchun. Qolgan hamma holat — uzilgan aloqa, deploy
  // paytidagi 5xx — quyidagi `loadFailed` juftligidan foydalanadi
  // (lib/tender-error.ts).
  'tender.notFound': 'Tender topilmadi',
  'tender.notFoundDesc': "Ehtimol u o'chirilgan yoki havola eskirgan.",
  'tender.loadFailed': "Tenderni yuklab bo'lmadi",
  'tender.loadFailedDesc': "Aloqani tekshiring va qayta urinib ko'ring.",
  'tender.seoDesc':
    "«{{title}}» — {{countryPrep}}gi dolzarb davlat xaridi. Byudjet, topshirish muddati, talablar va buyurtmachi ma'lumotlari — {{brand}}.",
  'tender.seoDescDefault':
    "{{countryGen}} tenderlari va davlat xaridlari: byudjet, muddat va buyurtmachi ma'lumotlari — {{brand}}.",
  // Deterministic key-facts paragraph (buildTenderFacts) — SEO + page fallback.
  'tender.facts.lead': '«{{title}}» — {{countryPrep}}gi davlat xaridi.',
  'tender.facts.region': "O'tkazish hududi — {{region}}.",
  'tender.facts.budget': "Boshlang'ich (maksimal) summa — {{budget}} {{currency}}.",
  'tender.facts.category': 'Toifa: {{category}}.',
  'tender.facts.deadline': 'Arizalar {{deadline}}-gacha qabul qilinadi.',
  'tender.facts.published': "E'lon qilingan sana: {{published}}.",
  'tender.facts.docs': 'Xaridga tender hujjatlari ilova qilingan ({{count}} ta fayl).',
  'tender.facts.label': 'Xarid haqida qisqacha',
  // Award outcome (winner + final price) — shown once a lot is awarded.
  'tender.outcome.label': 'Xarid natijasi',
  'tender.outcome.winner': "G'olib",
  'tender.outcome.winnerContact': "G'olib kontaktlari",
  'tender.outcome.winnerContactCapped':
    "Bugungi limitingiz — 200 ta kompaniya — tugadi. Biz g'ayrioddiy faollikni payqadik. Limitni olib tashlash uchun qo'llab-quvvatlash xizmatiga yozing",
  'tender.outcome.winnerContactCappedTelegram': 'Telegramda yozish',
  'companyData.link': "Bu sizning kompaniyangizmi? Telefonni yashirish yoki ma'lumotlarni tuzatish",
  'support.companyData.topic': "Mavzu: kompaniya ma'lumotlari, STIR {{tin}}",
  'support.companyData.prefill': "Kompaniya ma'lumotlari, STIR {{tin}}. ",
  'tender.buyer.profileLink': 'Buyurtmachi profili va uning barcha tenderlari →',
  'tender.outcome.finalPrice': 'Yakuniy narx',
  'tender.outcome.awardedAt': 'Qaror sanasi',
  'tender.outcome.failed': "Xarid bo'lib o'tmadi",
  'tender.outcome.locked': "G'olib aniqlandi. Nomi, summa va kontakti — Pro'da",
  'tender.outcome.lockedCta': 'Pro tarifini faollashtirish',
  'tender.outcome.lockedContactOnly': "G'olib aniqlandi. Nomi va kontakti — Pro'da",
  'tender.outcome.lockedPriceOnly': "G'olib aniqlandi. Nomi va summa — Pro'da",
  'tender.outcome.lockedWhoOnly': "G'olib aniqlandi. Nomi — Pro'da",
  'tender.outcome.lockedRow': "G'olib, summa va kontaktlar — Pro'da",
  'tender.outcome.lockedRowContact': "G'olib va uning kontaktlari — Pro'da",
  'tender.outcome.lockedRowPrice': "G'olib va summa — Pro'da",
  'tender.outcome.lockedRowWho': "G'olib — Pro'da",
  'tender.nav.siblings': 'Boshqa lotlar',
  'tender.siblings.headline': "Shu e'londa yana {{count}} ta {{lots}}, jami {{amount}}",
  'tender.siblings.headlineNoSum': "Shu e'londa yana {{count}} ta {{lots}}",
  'tender.siblings.hint': 'Ularning istalganiga ariza berish mumkin — har bir lotga alohida.',
  'tender.siblings.more': '+{{count}} ta yana',
  'tender.contactInfo': "Kontakt ma'lumotlari",
  'tender.contactDetails': "Kontakt ma'lumotlari ro'yxatdan o'tgan foydalanuvchilar uchun mavjud.",
  'tender.contactDetailsAuthed': "Buyurtmachi kontaktlarini ko'rish uchun oching.",
  'tender.opening': 'Ochilmoqda…',
  'tender.contactName': "Mas'ul shaxs",
  'tender.contactEmail': 'Email',
  'tender.contactPhone': 'Telefon',
  'tender.contactCategory': 'Faoliyat turi',
  'tender.contactWebsite': 'Sayt',
  'tender.contactTelegram': 'Telegram',
  'tender.contactMapAddress': 'Xaritadagi manzil',
  'tender.sourceLabel': 'Manba',
  'tender.openOriginal': 'Asl tenderni ochish',
  'tender.participateHint': 'Ariza berish va ERI olish',
  // Supply-scope (cooperation.uz) lots — the ONE, Pro-gated action; same label
  // whether the CTA is locked (→ /plans) or the real outbound link (Pro).
  'tender.openOriginalCoop': "cooperation.uz'dagi asl lotni ochish",
  'tender.documentsLabel': 'Tender hujjatlari',
  'tender.docsTeaser.tz': 'Texnik topshiriq',
  'tender.docsTeaser.contract': 'Shartnoma loyihasi',
  'tender.docsTeaser.spec': 'Spetsifikatsiya',
  'tender.docsTeaser.cta': 'Hujjatlarni ochish',
  'tender.docsTeaser.meteredCta': 'Hujjatlar platformada — havolani ochish ({{count}} tadan 1)',
  'tender.docsTeaser.meteredHint':
    "Fayllar platformada. Ochish asl e'longa havola va buyurtmachi kontaktlarini beradi — pastdagi tugma bilan bir xil amal.",
  'tender.docsTeaser.meteredOpenedCta': "Hujjatlar platformada — asl e'lonni ochish",
  'tender.procedureLabel': "O'tkazish tartibi",
  'tender.procedure.method': 'Protsedura turi',
  'tender.procedure.obligationTerm': 'Majburiyatlarni bajarish muddati',
  'tender.procedure.serviceType': 'Ish turi',
  'tender.procedure.financialSource': 'Moliyalashtirish manbasi',
  'tender.procedure.address': 'Manzil',
  'tender.procedure.deliveryAddress': 'Yetkazib berish manzili',
  'tender.procedure.decree': 'Asos',
  'tender.procedure.discussionStart': 'Muhokama boshlanishi',
  'tender.procedure.discussionEnd': 'Muhokama tugashi',
  'tender.procedure.published': "E'lon sanasi",
  'tender.procedure.positions': 'Pozitsiyalar',
  'tender.procedure.positionsHint':
    'Bu lotdagi turli tovar, ish yoki xizmatlar soni. Buyurtmachi ularni bitta xarid bilan oladi, taklif butun lotga beriladi.',
  'tender.procedure.docsDeadline': "Savol va e'tirozlar muddati",
  'tender.procedure.opening': 'Takliflar ochilish sanasi',
  'tender.procedure.announcementName': "E'lon",
  'tender.procedure.announcementNumber': "E'lon raqami",
  'tender.procedure.subjectKind': 'Xarid predmeti turi',
  'tender.procedure.planType': 'Reja bandi turi',
  'tender.procedure.organizer': 'Tashkilotchi',
  'tender.procedure.representative': 'Buyurtmachi vakili',
  'tender.procedure.bidStart': 'Arizalar qabul qilish boshlanishi',
  'tender.procedure.vatNote': 'Belgilar',
  'tender.procedure.commission': 'Tanlov komissiyasi',
  'tender.contactNone': "Bu tender uchun kontakt ma'lumotlari ko'rsatilmagan.",
  'tender.insufficientAllowance':
    "Kontakt ochishlar tugadi. Tarifni yangilang yoki qo'shimcha ochish sotib oling.",
  'tender.nicheRequired': 'Buyurtmachi kontaktlari Pro tarifida ochiladi.',
  'tender.proRequired':
    "Bu tender sizning yo'nalishingizdan tashqarida. Barcha tenderlar kontaktlari uchun Pro'ga o'ting.",
  'tender.revealError': "Kontaktni ochib bo'lmadi. Keyinroq urinib ko'ring.",
  'tender.upgradeCta': "Tariflarni ko'rish",
  // Region
  'region.backToCatalog': '← Katalogga qaytish',
  'region.title': '{{region}}dagi tenderlar',
  'region.loading': 'Yuklanmoqda…',
  'region.found': '{{count}} ta tender topildi',
  'region.seoTitle': '{{region}}: tenderlar va davlat xaridlari',
  // See the ru.ts note: paged titles use the short form so the page number survives
  // Google's ~60-char truncation once " — {{brand}}" is appended.
  'region.seoTitlePaged': '{{region}}dagi tenderlar — {{page}}-sahifa',
  'region.seoDesc':
    "{{region}}dagi dolzarb tenderlar va davlat xaridlari: {{count}} ta faol. Byudjet, muddat va buyurtmachi ma'lumotlari — {{brand}}'da.",
  'region.seoDescPaged':
    "{{region}}dagi tenderlar va davlat xaridlari — {{totalPages}} sahifadan {{page}}-si, jami {{count}} ta faol. Byudjet, muddat va buyurtmachilar — {{brand}}'da.",
  'region.intro':
    "{{region}}dagi davlat tenderlari va xaridlari: hozir {{count}} ta faol. Har bir e'londa byudjet, ariza topshirish muddati va rus hamda o'zbek tilida qisqacha tavsif mavjud. Toifalar bo'yicha filtrlang, qidiruvni saqlang va yangi tenderlarni Telegram orqali kuzating.",
  // Category
  'category.backToCatalog': '← Katalogga qaytish',
  'category.title': "{{category}} bo'yicha tenderlar",
  'category.loading': 'Yuklanmoqda…',
  'category.found': '{{count}} ta tender topildi',
  'category.topBuyers': 'Ushbu toifadagi asosiy buyurtmachilar',
  'category.seoTitle': 'Tenderlar: {{category}}',
  'category.seoTitlePaged': 'Tenderlar: {{category}} — {{page}}-sahifa',
  'category.seoDesc':
    "{{countryPrep}} «{{category}}» yo'nalishi bo'yicha tenderlar: {{count}} ta faol. Byudjet, muddat va buyurtmachilar — {{brand}}.",
  'category.seoDescPaged':
    "{{countryPrep}} «{{category}}» yo'nalishi bo'yicha tenderlar — {{totalPages}} sahifadan {{page}}-si, jami {{count}} ta faol. Byudjet, muddat va buyurtmachilar — {{brand}}.",
  'category.intro':
    "«{{category}}» — {{countryPrep}}gi davlat xaridlari yo'nalishlaridan biri. Hozir katalogda shu toifada {{count}} ta dolzarb tender bor: har birida boshlang'ich summa, ariza topshirish muddati va rus hamda o'zbek tilida qisqacha tavsif ko'rsatilgan. Hududni katalogda aniqlang, qidiruvni saqlang va yangi xaridlarni Telegram orqali oling.",
  // Guide
  'guide.backToCatalog': '← Katalogga qaytish',
  'guide.seriesHeading': 'Brokersiz tender: qadamma-qadam',
  'guide.articlesHeading': "Mavzu bo'yicha maqolalar",
  'guide.nicheGuidesHeading': "Yo'nalish qo'llanmalari",
  'guide.answersHeading': 'Qisqa javoblar',
  'guide.relatedHeading': "Mavzu bo'yicha yana",
  'guide.allArticles': "Qo'llanma maqolalari",
  // Login
  'login.title': 'Kirish',
  'login.subtitle': "{{brand}}'ga xush kelibsiz.",
  'checkout.identify.emailHint': 'Obunaga kirish shu manzilga keladi.',
  'checkout.identify.didYouMean': '{{email}} demoqchimisiz?',
  'checkout.identify.emailExample': 'Masalan: ism@gmail.com',
  'login.telegramWhy': "Telegram orqali tezkor kirish — ro'yxatdan o'tgandagidek.",
  'login.email': 'Email',
  'login.password': 'Parol',
  'login.signingIn': 'Kirilmoqda…',
  'login.signIn': 'Kirish',
  'login.continue': 'Davom etish',
  'login.codeTitle': 'Kodni kiriting',
  'login.codePrefilled': 'Xatdagi kod avtomatik kiritildi',
  'login.subtitleFor': 'Hisobga kirish',
  'login.or': 'yoki',
  'login.noAccount': "Hisobingiz yo'qmi?",
  'login.signUp': "Ro'yxatdan o'tish",
  // Register
  'register.title': "Ro'yxatdan o'tish",
  'register.subtitle': '{{brand}} hisobini yarating.',
  'auth.chosenPlan.month': '{{plan}} tarifi — oyiga {{price}} {{unit}}',
  'auth.chosenPlan.year': '{{plan}} tarifi — yiliga {{price}} {{unit}}',
  'register.pendingSearch': "Ro'yxatdan o'tgach, «{{name}}» qidiruvini saqlaymiz",
  'register.name': 'Ism',
  'register.phone': 'Telefon',
  'register.phonePlaceholder': '+998 90 123 45 67',
  'register.phoneInvalid': "To'g'ri raqam kiriting, masalan +998 90 123 45 67",
  'register.emailRequired': 'Email kiriting',
  'register.codeIncomplete': '6 raqamli kodni kiriting',
  'register.tin': 'STIR',
  'register.tinOptional': 'Ixtiyoriy',
  'register.tinHint': "9 raqam — yutgan tenderlaringizni ko'rsatamiz (ixtiyoriy)",
  'register.tinInvalid': "STIR aniq 9 ta raqamdan iborat bo'lishi kerak",
  'register.email': 'Email',
  'register.sendCode': 'Kod olish',
  'register.sendingCode': 'Yuborilmoqda…',
  'register.codeSentTo': 'Kodni shu manzilga yubordik:',
  'register.code': 'Xatdagi kod',
  'register.codeHint': 'Kod 10 daqiqa amal qiladi. Kelmadimi — «Spam» papkasini tekshiring.',
  'auth.otp.resend': 'Kodni qayta yuborish',
  'auth.otp.resendIn': 'Kodni {{seconds}} soniyadan keyin qayta yuborish mumkin',
  'auth.otp.notArrived': 'Kod bilan xat kelmadimi?',
  'auth.otp.notSentTo': 'Yangi kod shu manzilga yuborilmadi:',
  'auth.otp.rateLimited':
    "Kod juda ko'p so'raldi. {{minutes}} daqiqa kuting yoki oxirgi xatdagi havola orqali kiring.",
  'register.emailDidYouMean': 'Siz buni nazarda tutdingizmi:',
  'register.icloudSpam':
    "iCloud pochtasi xatlarimizni ko'pincha «Spam»ga yuboradi — papkani tekshiring. Yoki yuqoridan Telegram orqali kiring — bu tezroq.",
  'register.changeEmail': 'Boshqa manzil kiritish',
  'register.editEmail': "O'zgartirish",
  'register.telegramWhy':
    'Tender bildirishnomalari Telegramga keladi — shunda ular darrov ulanadi.',
  'register.password': 'Parol',
  'register.passwordHint': 'Kamida 8 ta belgi',
  'register.creating': 'Yaratilmoqda…',
  'register.createAccount': 'Hisob yaratish',
  'register.haveAccount': 'Hisobingiz bormi?',
  'register.signIn': 'Kirish',
  'auth.error.emailTaken': "Bu email allaqachon ro'yxatdan o'tgan. Hisobingizga kiring.",
  'auth.error.invalidCredentials': "Email yoki parol noto'g'ri.",
  'auth.error.generic': "Nimadir xato ketdi. Qayta urinib ko'ring.",
  // Domenida nuqtasi yo'q yoki TLD bir harfli manzil («ivan@gmail»,
  // «ivan@gmail.c»): server 400 validation_error qaytaradi, <input type=email>
  // esa o'tkazib yuboradi. Avval auth.error.generic ko'rsatilardi — aybni
  // o'zimizga olib, foydalanuvchiga tuzatadigan narsa bermasdan.
  'auth.error.emailSyntax':
    "Pochta manzilini tekshiring — xato bo'lsa kerak (masalan, .com yoki .uz yo'q)",
  'onboarding.banner.title': 'Profil sozlamalari: {{total}} tadan {{done}} ta',
  'onboarding.banner.titleShort': 'Profil: {{total}} tadan {{done}} ta',
  'onboarding.banner.show': "Ko'rsatish",
  'onboarding.banner.hide': 'Yashirish',
  'onboarding.banner.go': 'Ulash',
  'onboarding.banner.search': 'Saqlangan qidiruv',
  'onboarding.banner.telegram': 'Bildirishnomalar',
  'onboarding.banner.inn': 'Kompaniya STIRi',
  'onboarding.banner.email': 'Pochtani tasdiqlash',
  'onboarding.banner.activate': 'Kiritish',
  'onboarding.banner.noInn': 'Keyinroq',
  'onboarding.banner.emailWhy':
    'Pochtangizni tasdiqlang — shunda hisobingiz himoyalanadi va yangi tenderlar haqida bildirishnoma olasiz',
  'onboarding.banner.emailWhyShort': "To'plamlar pochtangizga kelishi uchun.",
  'onboarding.verifyEmail.send': 'Kod yuborish',
  'onboarding.verifyEmail.verify': 'Tasdiqlash',
  'onboarding.inn.title': 'Tashkilotingiz nomi yoki STIRi?',
  'onboarding.inn.subtitle':
    "Kompaniyangiz nimalarda g'alaba qozonganini va sohangizda hozir nechta tender ochiqligini ko'rsatamiz.",
  'onboarding.inn.skip': "O'tkazib yuborish",
  'onboarding.inn.digitsHint': 'Aniq {{digits}} ta raqam kerak',
  'onboarding.inn.next': 'Keyingisi',
  'auth.error.passwordRequired': 'Parolni kiriting',
  'auth.error.invalidCode':
    "Kod to'g'ri kelmadi: u eskirgan yoki o'rniga yangisi yuborilgan bo'lishi mumkin. Yangi kod so'rang.",
  'auth.error.invalidPhone': 'Telefon raqamini tekshiring.',
  // Dashboard
  'dashboard.title': '{{brand}} — boshqaruv paneli',
  'dashboard.signedInAs': '{{email}} sifatida kirilgan.',
  'dashboard.signOut': 'Chiqish',
  // SEO
  'seo.landing.title': '{{brand}} — Biznes imkoniyatlarini toping',
  'seo.landing.description':
    "Mamlakat bo'ylab davlat tenderlarini ko'rib chiqing. Hudud, toifa va holat bo'yicha filtrlang.",
  'seo.catalog.title': '{{country}} davlat xaridlari va tenderlari',
  'seo.catalog.description':
    "{{country}} davlat xaridlari va tenderlari katalogi: dolzarb xaridlar, o'zbek va rus tilida xaridlar tahlili, hudud va toifa bo'yicha filtrlar, Telegram bildirishnomalari — {{brand}}'da.",
  // Ro'yxatning N-sahifasi. Alohida title shart: aks holda har bir sahifa bir xil
  // sarlavha oladi va Google ularni dublikat sifatida birlashtiradi — holbuki
  // ular katalog chuqurligiga ichki havola berish uchun mavjud.
  'seo.catalog.titlePaged': '{{country}} davlat xaridlari va tenderlari — {{page}}-sahifa',
  // «tender natijalari» — Search Console shows the query in exactly this form
  // (53 impressions / 28 days to 22.09, position 5.2, all of them landing on
  // /results/page/N, 0 clicks); keep the phrase verbatim instead of the inflected «tenderlari
  // natijalari» so the hub itself carries it.
  'seo.results.title': "{{country}} tender natijalari: g'oliblar va narxlar",
  'seo.results.titlePaged': '{{country}} tender natijalari — {{page}}-sahifa',
  'seo.results.description':
    "{{country}}dagi g'olibi aniqlangan yakunlangan xaridlar. G'olib, summa va kontaktlar — Pro'da; filtrlar va qidiruvni saqlash — bepul.",
  'results.page.h1': 'Tender natijalari',
  'results.page.intro': 'Oxirgi oyda yakunlangan xaridlar: kim va qanchaga yutgan.',
  // ── /results card «Что вы поставляете?» (feat/results-search, 2026-10-07) ──
  'results.card.title': 'Nima yetkazib berasiz?',
  'results.card.sub': "Bunday xaridlarda kim yutganini ko'rsatamiz.",
  'results.card.placeholder': 'guruch, un, nasoslar…',
  'results.card.inputLabel': "So'zlar, kategoriyalar va YeNKT kodlari",
  'results.card.remove': '«{{label}}»ni olib tashlash',
  'results.card.category': 'Kategoriya:',
  'results.card.ikpu': 'YeNKT',
  'results.suggest.word': "So'z:",
  'results.suggest.wordHint': 'nom va tavsifda',
  'results.suggest.foot': "↵ — so'z sifatida qo'shish · kategoriya aniqroq, so'z kengroq",
  'results.refine': 'Aniqlashtirish',
  'results.refine.empty': 'hudud · summa · istisnolar',
  'results.refine.region': 'Hudud',
  'results.refine.addRegion': '+ hudud',
  'results.refine.sum': 'Lot summasi, {{currency}}',
  'results.refine.from': 'dan',
  'results.refine.to': 'gacha',
  'results.refine.any': 'istalgan',
  'results.refine.sumFrom': '{{amount}} dan',
  'results.refine.sumTo': '{{amount}} gacha',
  'results.refine.exclude': "Bu so'zlar bilan yubormaslik",
  'results.refine.excludePlaceholder': "so'z…",
  'results.refine.excludeCount': "{{count}} ta so'zsiz",
  'results.refine.kind': 'Xarid turi',
  'results.refine.customer': 'Buyurtmachi',
  'results.refine.customerLabel': 'Buyurtmachi {{tin}}',
  'results.kind.goods': 'Tovarlar',
  'results.kind.works': 'Ishlar',
  'results.kind.services': 'Xizmatlar',
  'results.count.found': '{{count}} ta {{word}}',
  'results.count.period': 'oxirgi oyda topildi',
  'results.count.week': 'haftada {{count}} ta',
  'results.count.today': 'bugun {{count}} ta',
  'results.count.loading': 'Natijalar hisoblanmoqda…',
  'results.save': 'Qidiruvni saqlash',
  'results.update': 'Qidiruvni yangilash',
  'results.saved': 'Qidiruv saqlangan',
  'results.save.empty': "So'z qo'shing — qidiruvni saqlash mumkin",
  'results.save.guest': "Bepul — ro'yxatdan o'tish kerak bo'ladi",
  'results.save.note': 'Bitta akkauntga bitta natijalar qidiruvi — yangi saqlash uni yangilaydi',
  'results.save.error': "Qidiruvni saqlab bo'lmadi. Yana urinib ko'ring",
  'results.changed': "O'zgardi: {{list}} — saqlash uchun qidiruvni yangilang",
  'results.updated': 'Yangilandi: {{list}}',
  'results.created':
    'Saqlandi. Yangi natijalar haqida bildirishnomalar — bildirishnoma sozlamalarida',
  'results.change.region': 'hudud',
  'results.change.budget': 'summa',
  'results.change.exclude': 'istisnolar',
  'results.change.kind': 'xarid turi',
  'results.change.customer': 'buyurtmachi',
  'results.change.text': "so'zlar",
  'results.change.category': 'kategoriyalar',
  'results.change.ikpu': 'YeNKT kodlari',
  'results.change.name': 'nomi',
  'results.wall.line': "G'oliblar kontaktlari, STIR va summalari — Pro'da",
  'results.wall.cta': 'Pro tarifini faollashtirish',
  'savedSearches.results.name': 'Natijalar',
  'savedSearches.results.hint': "O'xshash xaridda g'olib aniqlanganda bildirishnoma",
  'savedSearches.results.edit': "Natijalar sahifasida o'zgartirish",
  // ── m16 app shell ──────────────────────────────────────────────
  // Shortened from «Tenderlarni ma'no bo'yicha qidirish…», which measured
  // 269.7px against 247px of available width at 390×844 and was cut mid-word.
  // Dropping «Tenderlarni» costs nothing — the field sits in the catalog header,
  // so what is being searched is not in question — and matches how compact the
  // Russian string already is.
  'shell.search.placeholder': "Ma'no bo'yicha qidirish…",
  'shell.search.ai': 'AI',
  'shell.section.catalog': 'Katalog',
  'shell.section.regions': 'Hududlar',
  'shell.section.categories': 'Toifalar',
  'shell.showAll': "Hammasini ko'rsatish ({{count}})",
  'shell.showLess': "Yig'ish",
  'shell.section.savedSearches': 'Saqlangan qidiruvlar',
  'shell.saved.guestCta': "O'z qidiruvingizni saqlang",
  'shell.nav.allTenders': 'Barcha tenderlar',
  'shell.nav.ifiProjects': 'XMI loyihalari',
  'shell.nav.supplyRequests': 'Kooperatsiya',
  'shell.nav.favorites': 'Tanlanganlar',
  'favorites.title': 'Tanlanganlar',
  'favorites.subtitle': "Keyinroq qaytish uchun saqlab qo'ygan tenderlaringiz.",
  'favorites.empty.title': "Hozircha bo'sh",
  'favorites.empty.desc': "Tenderni tanlanganlarga qo'shish uchun kartadagi ☆ tugmasini bosing.",
  'favorites.empty.cta': "Katalogga o'tish",

  // ── «Mening tenderlarim» (/app/my-tenders) ────────────────────────────────
  // Saqlangan qidiruvlarga mos kelgan hamma lot, jumladan digest shifti kesib
  // tashlaganlari ham. Sahifa faqat ikki va undan ortiq faol qidiruvda ochiladi.
  'myTenders.title': 'Mening tenderlarim',
  'myTenders.subtitle':
    'Saqlangan qidiruvlaringizga mos keladigan barcha tenderlar, yangilari yuqorida',
  'myTenders.chip.all': 'Hammasi',
  'myTenders.showClosed': "Yopilganlarni ko'rsatish",
  'myTenders.total': 'Jami: {{count}}',
  'myTenders.bySearch': "qidiruv bo'yicha: {{names}}",
  'myTenders.new': 'yangi',
  // Nishon ko'rinib turganda yon panel qatorining butun nomi. Nishonning o'zi
  // aria-hidden: alohida o'qilgan «5» hech narsani anglatmaydi.
  'myTenders.newCountAria': 'Mening tenderlarim, yangi mosliklar: {{count}}',
  'myTenders.empty.title': "Hozircha mos keladigani yo'q",
  'myTenders.empty.descOpen':
    "Qidiruvlaringiz bo'yicha ochiq tender yo'q. «Yopilganlarni ko'rsatish»ni yoqing yoki «Bildirishnomalar» sahifasida qidiruvni o'zgartiring.",
  'myTenders.empty.desc':
    "Qidiruvlaringiz bo'yicha hozircha birorta ham tender yo'q. Shartlarni «Bildirishnomalar» sahifasida o'zgartiring.",
  'shell.nav.alerts': 'Bildirishnomalar',
  'shell.nav.menu': 'Menyu',
  'shell.nav.menu.a11yDesc': "Sayt bo'limlari, saqlangan qidiruvlar va hisob sozlamalari.",
  'shell.nav.openMenu': 'Menyuni ochish',
  'shell.nav.closeMenu': 'Menyuni yopish',
  'shell.saved.empty': "Hozircha saqlangan qidiruvlar yo'q",
  'catalog.saveSearch': 'Qidiruvni saqlash',
  'catalog.saveSearchGuest':
    "Bepul ro'yxatdan o'ting — qidiruv saqlanadi va yangi tenderlarni yuboramiz",
  'catalog.saveSearchPickFirst': 'Avval toifani tanlang',
  'saved.close': 'Yopish',

  // ── «Saqlangan qidiruvlar» (/app/alerts) ──────────────────────────────────
  'savedSearches.title': 'Saqlangan qidiruvlar',
  'savedSearches.edit': 'Tahrirlash',
  'savedSearches.summary.from': '{{amount}}-dan',
  'savedSearches.summary.to': '{{amount}}-gacha',
  'savedSearches.summary.except': '{{terms}}dan tashqari',
  'savedSearches.rate': 'kuniga ≈ {{count}} ta lot',
  // ⚠️ «0 ta» emas: nol «qidiruv hech narsa topmayapti» deb o'qiladi, aslida
  // esa hali o'lchamaganmiz — rate bir haftalik tarixdan keyin paydo bo'ladi.
  'savedSearches.rate.unknown': "ma'lumot yetarli emas",
  'savedSearches.rate.unknownHint':
    "qidiruvning bir haftalik tarixi to'planganda chastotani ko'rsatamiz",
  'savedSearches.delete.title': "Qidiruvni o'chirish",
  'savedSearches.delete.confirm':
    "«{{name}}» qidiruvi o'chirilsinmi? U bo'yicha bildirishnomalar kelmay qo'yadi.",
  'savedSearches.instant': 'Darhol yuborilsin',
  'savedSearches.instant.hint':
    "Har bir yangi lot — digestni kutmasdan, alohida xabar bilan. Faqat aniq qidiruvlar uchun (kuniga 3 tagacha lot); soatiga 5 tadan ko'p emas.",
  'savedSearches.instant.no.broad':
    "Faqat aniqlashtirilgan qidiruvlar uchun (so'z, YeNKT, hudud, yo'nalish…)",
  'savedSearches.instant.no.rate':
    "Bu qidiruv kuniga ≈{{count}} ta beradi — alohida xabarlar uchun juda ko'p",
  'savedSearches.instant.no.young': "Chastotani baholab bo'lmadi — keyinroq urinib ko'ring",
  'savedSearches.instant.no.plan': "Pro'da mavjud",
  'savedSearches.instant.rejected':
    "O'zgartirib bo'lmadi: qidiruv endi alohida xabarlarga to'g'ri kelmaydi. Sahifani yangilang.",
  'saved.deleteYes': 'Ha',
  'saved.delete': "O'chirish",
  'saved.edit': "O'zgartirish",
  'saved.matches': 'Hozir mos tenderlar: {{n}}',
  'saved.rate': "Haftasiga ≈{{n}} ta shu filtr bo'yicha",
  'saved.minBudgetLabel': 'Byudjet, {{currency}}dan',
  'saved.minBudgetPlaceholder': '500 000 000',
  'saved.maxBudgetLabel': 'Byudjet, {{currency}}gacha',
  'saved.maxBudgetPlaceholder': '1 000 000 000',
  'saved.budgetRangeError': "«Gacha» qiymati «dan» qiymatidan kam bo'lishi mumkin emas.",
  'saved.learnedLabel': "👎 belgilaringiz bo'yicha chiqarib tashlangan (qaytarish uchun bosing)",
  'saved.learnedRemove': 'Qaytarish',
  'saved.excludeTermsLabel': "Shu so'zlar bor tenderlarni yubormaslik",
  'saved.excludeTermsPlaceholder': 'vergul bilan ajrating',
  'saved.excludeTermsHint': "Shu so'zlardan biri bor tender bildirishnomaga tushmaydi.",
  'tagInput.remove': '«{{term}}»ni olib tashlash',
  'tagInput.max': "Ko'pi bilan {{count}} ta",
  'tagInput.tooLong':
    "Juda uzun: {{count}} belgi, ko'pi bilan {{max}}. Bir-ikki so'zgacha qisqartiring.",
  'saved.matchesNone':
    "Hozir bu filtrlarga mos ochiq tender yo'q — mos tender paydo bo'lmaguncha bildirishnoma kelmaydi. Filtrni kengaytirib ko'ring.",
  'saved.nameLabel': 'Nomi',
  'saved.defaultName': 'Mening qidiruvim',
  'saved.save': 'Saqlash',
  'saved.cancel': 'Bekor qilish',
  'saved.edit.title': 'Qidiruvni sozlash',
  'saved.edit.a11yDesc': 'Obuna nomi, toifalari, istisnolari va eng kam byudjeti.',
  'saved.edit.saving': 'Saqlanmoqda…',
  'saved.edit.error': "Saqlab bo'lmadi",
  'saved.edit.errorSubject':
    "Kamida bittasini qoldiring: toifa, YeNKT, yo'nalish, buyurtmachi yoki so'z.",
  'saved.edit.errorInvalid': "Saqlab bo'lmadi: maydonlarni tekshirib, yana urinib ko'ring.",
  'saved.edit.errorTerms':
    "So'zlar juda ko'p yoki so'z juda uzun. Ortiqchasini olib tashlab, qayta saqlang.",
  'saved.saved': 'Saqlandi',
  'saved.toast': 'Qidiruv saqlandi',
  'saved.tender.add': 'Tanlanganlarga',
  'saved.tender.remove': 'Tanlangandan olib tashlash',
  'saved.limitReached':
    "Bepul tarifda ko'pi bilan {{n}} ta saqlangan qidiruvga ruxsat bor. Cheklovsiz saqlash uchun Pro'ni rasmiylashtiring.",
  'saved.errorGeneric': "Qidiruvni saqlab bo'lmadi. Yana urinib ko'ring.",
  'saved.emptyCriteria': "Kamida bitta filtr qo'shing — toifa, hudud, kalit so'z yoki byudjet.",
  'alert.picker.title': 'Qaysi bildirishnomani sozlash kerak?',
  'alert.picker.createNew': 'Yangisini yaratish',
  'saved.tuneAlert': 'Bildirishnomalarni sozlash',
  'saved.deleteAlert': "Bildirishnomani o'chirish",
  'saved.deleteConfirm': "Ha, o'chirish",
  'saved.deleteWarning':
    "Bu qidiruv bo'yicha xabarlar kelmay qo'yadi. Yangisini katalogdan yaratish mumkin.",
  'shell.user.signIn': 'Kirish',
  'shell.user.guest': 'Mehmon',
  'shell.user.notSignedIn': 'Kirilmagan',
  'shell.user.freePlan': 'Bepul tarif',
  'shell.user.paidPlan': '{{plan}} tarifi',
  'shell.upgrade.label': "Pro'ga o'tish",
  'shell.upgrade.desc': 'Buyurtmachilar kontaktlari, hujjatlar va tahlil',
  // ── Connect Telegram for alerts ──────────────────────────────────
  'telegram.connect.title': "Bildirishnomalar uchun Telegram'ni ulang",
  'telegram.connect.desc':
    "Yo'nalishingiz bo'yicha yangi tenderlarni to'g'ridan-to'g'ri Telegram'da oling. Quyidagi tugmani bosing va botga yozishga ruxsat bering.",
  'telegram.connect.benefit1': "Saqlangan qidiruvlar bo'yicha tezkor bildirishnomalar",
  'telegram.connect.benefit2': 'Yetkazib beruvchilar uchun mos tenderlar haqida xabar',
  // BIZNING ulash tugmamiz yozuvi — to'rttala yuzada BITTA (onboarding
  // chizig'i, modal, kabinet kartochkasi, katalog banneri). 18.10 dan tugma
  // botga olib boradi (telegram.org vidjeti saytda yo'q). Qator tor — ikki so'z.
  'telegram.connect.cta': 'Telegramni ulash',
  'telegram.bot.cta': 'Telegram orqali kirish',
  'telegram.bot.waiting': "Telegramda Start tugmasini bosing — kirish o'zi amalga oshadi",
  'telegram.bot.waitingConnect': "Telegramda Start tugmasini bosing — u o'zi ulanadi",
  'telegram.bot.waitingDesktop': 'Telegramni oching va Start tugmasini bosing. Kutyapmiz…',
  'telegram.bot.reopen': 'Telegramni yana ochish',
  'telegram.bot.inAppHint':
    "Telegram ochilmadimi? {{app}}da yuqori o'ngdagi ⋯ ni bosing → «Brauzerda ochish».",
  'telegram.bot.notOpenedHint': 'Telegram ochilmadimi? Havolani nusxalang va brauzerda oching.',
  'telegram.bot.copyLink': 'Havolani nusxalash',
  'telegram.bot.copied': 'Havola nusxalandi',
  'telegram.bot.expired': "Bo'lmadi — yana bosing.",
  'telegram.bot.connected': 'Telegram ulandi',
  'telegram.bot.failed': "Telegram orqali kirishni tayyorlab bo'lmadi. Tugmani yana bosing.",
  'telegram.magic.signingIn': 'Kirilmoqda…',
  'telegram.magic.expired':
    'Kirish havolasi eskirgan yoki allaqachon ishlatilgan. Telegram orqali yana kiring — bu bitta tugma.',
  'telegram.magic.toLogin': 'Kirish',
  'telegram.magic.toSite': "Saytga o'tish",
  'telegram.magic.checking': 'Havola tekshirilmoqda…',
  'telegram.magic.confirmAs': '{{name}} sifatida kirasizmi?',
  'telegram.magic.confirm': 'Telegram orqali kirasizmi?',
  'telegram.magic.confirmHint':
    "Telegram-botimizdagi havola orqali kirish. Bu sizning Telegramingiz bo'lmasa, «Bu men emas»ni bosing.",
  'telegram.magic.signIn': 'Kirish',
  'telegram.magic.notMe': 'Bu men emas',
  'telegram.magic.linking': 'Telegram ulanmoqda…',
  'telegram.magic.mismatch':
    "Bu havola boshqa hisob uchun. Siz saytga o'z hisobingiz bilan kirgansiz — unda hech narsa o'zgarmadi.",
  'telegram.connect.mismatch':
    "Bu Telegram orqali kirish boshqa hisobdan boshlangan — hech narsa o'zgarmadi. Tugmani yana bosing.",
  'telegram.connect.error': "Telegram'ni ulab bo'lmadi. Qayta urinib ko'ring.",
  'telegram.connect.taken':
    "Bu Telegram allaqachon boshqa {{brand}} hisobiga bog'langan. O'sha hisobga kiring yoki avval Telegram'ni undan uzing. Telegram hisobini almashtirish uchun Telegram tugmasidagi «Chiqish»ni bosing (unda kirgan foydalanuvchi ismi ko'rinadi) va o'z hisobingiz bilan kiring.",
  'telegram.connect.hasTeam':
    "Bu Telegram jamoaga a'zo bo'lgan hisobga bog'langan. Bunday hisobni avtomatik birlashtirib bo'lmaydi — {{brandEmail}}'ga yozing.",
  'telegram.connect.hasAssets':
    "Bu Telegram obunasi, to'lovlari yoki boshqa shaxsiy ma'lumotlari bor hisobga bog'langan. Bunday hisobni avtomatik birlashtirib bo'lmaydi — o'sha hisobga kiring yoki {{brandEmail}}'ga yozing.",
  'telegram.status.connected': 'Telegram ulangan',
  'telegram.status.desc': "Saqlangan qidiruvlar bo'yicha bildirishnomalar Telegramga keladi.",
  'telegram.disconnect.cta': 'Uzish',
  'telegram.disconnect.pending': 'Uzilmoqda…',
  'telegram.disconnect.confirm':
    "Telegram uzilsinmi? Qayta ulamaguningizcha bildirishnomalar to'xtaydi.",
  // ── Tender row / list ──────────────────────────────────────────
  'tender.status.active': 'Faol',
  'tender.publishedShort': "e'lon qilingan",
  'tender.number.copyLabel': "E'lon raqami {{number}} — nusxalash",
  'tender.number.copied': 'Nusxalandi',
  'tender.status.closing': 'Tez orada yopiladi',
  'tender.status.closed': 'Yakunlangan',
  'tender.ai': 'AI',
  'tender.budget.unit': '{{currency}}',
  'teaser.srLocked': 'Pro tarifida mavjud',
  'teaser.openPlans': "{{card}} — Pro tarifida, tariflarni ko'rish",
  'tender.budget.undisclosed': "Ko'rsatilmagan",
  'tender.notice.ifb': 'Savdoga taklif',
  'tender.notice.reoi': "Qiziqish bildirish so'rovi",
  'tender.notice.gpn': 'Umumiy bildirishnoma',
  'tender.notice.advance': 'Dastlabki bildirishnoma',
  'tender.notice.firm': 'Konsultantlarni tanlash',
  // Detal sahifadagi bilan bir xil (tender.overview.bidSecurity): yonidagi
  // qiymat endi yo summa, yo foiz stavkasi, shuning uchun yalang'och
  // «Kafillik: 1» «1 {{currency}}» deb o'qilardi.
  'tender.bidSecurity': "Ariza ta'minoti",
  'tender.deadline.closes': 'Yopiladi',
  'tender.deadline.tba': 'Aniqlanmagan',
  'tender.deadline.announcement': 'Tez orada arizalar qabuli',
  'tender.deadline.announcementNote':
    "Bu anons: tender e'lon qilingan va rejalashtirilgan, arizalar qabuli hali ochilmagan. Yo'qotib qo'ymaslik uchun uni tanlanganlarga qo'shing.",
  'tender.singleSupplier.badge': 'Bitta yetkazib beruvchiga taklif',
  'tender.singleSupplier.hint':
    "Bo'lib o'tmagan xaridlar bo'yicha yagona manbadan: arizani faqat taklif qilingan yetkazib beruvchi beradi",
  'tender.singleSupplier.note':
    "Bo'lib o'tmagan xaridlar bo'yicha yagona manbadan xarid: avvalgi tartib bo'lib o'tmadi va buyurtmachi bitta yetkazib beruvchini taklif qildi. Arizani faqat u bera oladi. Lot buyurtmachi talabini ko'rishingiz uchun ko'rsatilgan; bunday lotlar bildirishnomalarga tushmaydi.",
  'tender.bidsOpen.from': 'Arizalar qabuli boshlanishi: {{date}}',
  'tender.similar.title': "O'xshash tenderlar",
  'tender.closedNoOutcome.title': 'Arizalar qabuli {{date}} yakunlandi',
  'tender.closedNoOutcome.titleNoDate': 'Arizalar qabuli yakunlandi',
  'tender.closedNoOutcome.body': "Natijalar hali e'lon qilinmagan.",
  'tender.similarLive.title': "O'xshash ochiq lotlar",
  'tender.similarLive.follow': "Shunga o'xshashlarni kuzatish",
  'list.col.tender': 'Tender',
  'list.col.budget': 'Byudjet',
  'list.col.noticeType': 'Bildirishnoma turi',
  'list.col.deadline': 'Muddat',
  // Lendinglardagi (/start, /ip) LotCard uchun label'lar — list.col.* bilan
  // bir xil ma'noda, lekin alohida kalitlar: lending kartochkasi katalog
  // jadvali ustunlarini bevosita ishlatmaydi.
  'landing.lotCard.contactLabel': 'Buyurtmachi kontakti',
  'landing.lotCard.lockLabel': "Pro'da",
  'landing.lotCard.activeLabel': 'Faol',
  'landing.lotCard.docsLabel': 'TT va shartnoma',
  // Alohida kalit, tender.bidSecurity emas: maketdagi lending matni
  // («Ta'minot») katalogdagi («Kafillik») dan farq qiladi — birini
  // tuzatish ikkinchisiga ta'sir qilmasligi kerak.
  'landing.lotCard.bidSecurityLabel': "Ta'minot",
  // «N kun qoldi» shabloni — o'zbekchada son bilan kelgan ot turlanmaydi
  // (daysWord — lib/format.ts — 'kun'ni invariant qaytaradi), lekin
  // {{word}} baribir uzatiladi — shablonlar bir xil kalitdan o'qiladi.
  'landing.lotCard.daysLeft': '{{n}} {{word}} qoldi',
  // /ip sahifasidagi nisha almashtirgichining bo'sh holati: nisha bor, lekin
  // uning jonli natijasida hozircha bitta ham lot yo'q — bo'sh katakcha o'rniga.
  'landing.nicheSwitcher.emptyLabel':
    "Hozir bu yo'nalishda faol lotlar yo'q — toifani to'liq ochib ko'ring.",
  // «Что меняет Pro» blokidagi Telegram-chat mokapining accessible yorlig'i.
  'landing.illustration.chatLabel': 'Telegram-bildirishnomalar namunasi',
  // G'olib narxi diapazoni shkalasining accessible tavsifi («Bozor ma'lumotlari» paneli).
  'landing.illustration.rangeAriaLabel':
    '{{label}}: {{min}}-dan {{max}}-gacha, bu pozitsiya — {{pct}}%',
  'search.empty.title': "Hozircha bunday tenderlar yo'q",
  // ⚠️ Bu satrda lotlar soni BO'LMASIN — ru.ts dagi izohga qarang.
  'search.empty.body':
    "Hozircha katalogda mos lot yo'q. Obuna bo'ling — e'lon qilingan kuni Telegramga xabar yuboramiz.",
  // ⚠️ ru.ts dagi izohga qarang — hech qaysi satr "hech narsa topilmadi" demasin.
  'niche.hint.applied':
    "Siz «{{niche}}» yo'nalishini qidirayotganga o'xshaysiz — uning lotlari qo'shildi.",
  'niche.hint.suggest': "Siz «{{niche}}» yo'nalishini qidirayotganga o'xshaysiz.",
  'niche.hint.open': "Yo'nalishni ochish →",
  'niche.hint.ambiguous': "Ehtimol, siz quyidagi yo'nalishlardan birini qidiryapsiz:",
  'catalog.lotNumberMatch.one': 'Lot № {{n}} topildi',
  'catalog.lotNumberMatch.many': '№ {{n}} raqamli lotlar topildi',
  'org.hint.intro': '«{{q}}» — bu tashkilot STIRi. Uning profilini oching:',
  'org.hint.buyer': '{{name}} — buyurtmachi',
  'org.hint.supplier': '{{name}} — yetkazib beruvchi',
  'list.density.normal': 'Oddiy',
  'list.density.compact': 'Ixcham',
  'list.empty': "Joriy filtrlarga mos tenderlar yo'q.",
  'list.bidPackageReady': 'Ariza tayyor',
  // Short layer tag on a search-result row (a search spans every layer).
  'ifi.badge': 'XMI',
  'supply.badge': 'Kooperatsiya',
  'scope.chips.aria': "Katalog bo'limi bo'yicha filtr",
  'ifi.page.h1': 'XMI loyihalari',
  'ifi.page.intro':
    "Xalqaro institutlar moliyalashtirgan loyihalar bo'yicha xaridlar. Buyurtmachi — O'zbekiston idorasi, moliyalashtirish bank tomonidan, shuning uchun byudjet {{currency}}da emas, loyiha valyutasida e'lon qilinadi.",
  // #52 — «Проекты по ведомствам»
  'ifi.projects.title': 'Idoralar kesimidagi loyihalar',
  'ifi.projects.emptyForSource':
    "Bu institut ijrochi idorani e'lon qilmaydi — shu sababli kesim bo'sh.",
  'ifi.projects.subtitle':
    'Xalqaro institutlar loyihalari buyurtmachi vazirlik va idoralar kesimida.',
  'ifi.source.aria': 'Institut',
  'ifi.source.all': 'Hammasi',
  'ifi.source.worldbank': 'Jahon banki',
  'ifi.source.adb': 'ADB',
  'ifi.source.aiib': 'AIIB',
  'ifi.source.undp': 'BMTTD',
  'ifi.source.ungm': 'UNGM',
  'ifi.source.isdb': 'IsDB',
  'ifi.source.ebrd': 'EBRD',
  'ifi.source.uzrd': 'UzRD',
  'ifi.source.osce': 'YeXHT',
  'ifi.source.ariaLabel': '{{label}}, {{count}} ta tender',
  // Kazakhstan-only chips (`govSources` is empty on UzTender, so these never
  // render here); kept for key parity.
  'catalog.source.aria': 'Platforma',
  'catalog.source.all': 'Hammasi',
  'catalog.source.goszakup': 'Davlat xaridlari',
  'catalog.source.samruk': 'Samruk-Kazyna',
  'catalog.source.mitwork': 'Mitwork',
  'catalog.source.skpharmacy': 'SK-Farmatsiya',
  'catalog.source.medecc': 'Tibbiyot tashkilotlari',
  'catalog.source.erg': 'ERG',
  'catalog.source.qarmet': 'Qarmet',
  'catalog.source.tizilim': 'Tizilim',
  'catalog.source.ccx': 'Caspy Tender',
  'catalog.source.eurasiantech': 'EurasianTech',
  'catalog.source.etsTender': 'ETS-Tender',
  'catalog.source.kgGoszakupki': 'Davlat xaridlari (yangi portal)',
  'catalog.source.kgZakupkiGov': 'zakupki.gov.kg',
  'catalog.source.kgZakupkiOkmot': 'Davlat kompaniyalari (zakupki.okmot.kg)',
  'catalog.source.ariaLabel': '{{label}}, {{count}} ta tender',
  'ifi.seo.title': '{{countryPrep}} Jahon banki, ADB va BMT agentliklari tenderlari',
  'ifi.seo.description':
    "{{countryPrep}} xalqaro moliya institutlari loyihalari bo'yicha ochiq xaridlar: Jahon banki, ADB, AIIB, BMT agentliklari. Muddatlar, hujjatlar, talablar.",
  // Task 10 — cooperation.uz reverse-auction supply requests: thin, budgetless
  // leads shown as their own opt-in section, deliberately `noindex` (see
  // isTenderIndexable in lib/tender-status.ts).
  'supply.page.h1': "Kooperatsiya: ta'minot so'rovlari",
  'supply.page.intro':
    "cooperation.uz savdo maydonchasidan ta'minot so'rovlari — {{currency}}da e'lon qilingan byudjetsiz, shuning uchun alohida bo'limga ajratilgan va asosiy katalogga kirmaydi.",
  'supply.seo.title': "Kooperatsiya: cooperation.uz ta'minot so'rovlari",
  'supply.seo.description':
    "cooperation.uz savdo maydonchasidagi mahsulot va xizmatlarga ta'minot so'rovlari — {{currency}}dagi byudjetsiz.",
  // ── Filter bar ─────────────────────────────────────────────────
  'filter.label': 'Filtr:',
  'filter.region': 'Hudud',
  // Buyer (заказчик) subscription axis — active-filter chip label on the
  // catalog, e.g. «Buyurtmachi: DUK …». Removal reuses `filter.chip.remove`.
  'filter.customer': 'Buyurtmachi',
  'filter.category': 'Toifa',
  'filter.ikpu.label': "Yoki tovar kodi bo'yicha",
  'filter.ikpu.allUnder': 'Barcha {{code}} kodlari',
  'filter.ikpu.searchWords': "Bunday kod yo'q — «{{q}}» so'zlari bo'yicha lotlarda qidirish",
  'filter.ikpu.noCodeHint':
    "Bunday so'zli kod yo'q. Nima yetkazib berishingizni bir so'z bilan yozing, masalan «mebel» yoki «reklama»",
  // Ablative «{{total}} tadan {{n}} tasi» — "n of the total" as Uzbek actually
  // says it, not a word-for-word calque of the Russian «{{n}} из {{total}}».
  'filter.ikpu.countOfParent': '{{total}} tadan {{n}} tasi',
  // Disclosure toggle on a collapsible ИКПУ section header — the accessible
  // name for the twisty button, distinct from the row's own label (which
  // SELECTS the section rather than expanding it).
  'filter.ikpu.expand': "Bo'limni ochish",
  'filter.ikpu.collapse': "Bo'limni yopish",
  'filter.more.categories': 'Yana {{count}} ta toifa',
  'filter.chip.remove': 'Olib tashlash: {{name}}',
  'filter.ikpu.pickedInside': 'Ichida tanlangan: {{count}}',
  'filter.more.niches': "Yana {{count}} ta yo'nalishni ko'rsatish",
  'filter.more.ikpu': "Yana kodlarni ko'rsatish",
  'filter.status': 'Holat',
  'filter.all': 'Barchasi',
  'filter.selectCategory': 'Toifani tanlang',
  'filter.niche': 'Toifa yoki tovar',
  'filter.niche.search': 'Qidiruv: toifa yoki tovar…',
  // Screen-reader-only live announcement in the multi-select picker (the
  // checkbox fill/reorder that sighted users see on a pick is otherwise
  // silent to a screen reader).
  'filter.multi.selectedCount': 'Tanlandi: {{count}}',
  // Niches (Spec #3 classification layer) shown in the search results, above
  // raw ИКПУ codes — shared between the catalog filter and onboarding.
  'niche.section': "Yo'nalishlar",
  'niche.badge': "yo'nalish",
  'filter.status.active': 'Faol',
  'filter.status.closing': 'Tez orada yopiladi',
  'filter.status.closed': 'Yopilgan',
  'filter.status.all': 'Barchasi',
  'filter.clear': 'Filtrlarni tozalash',
  'result.count': '{{count}} ta {{word}}',
  'result.countAtLeast': '{{count}} ta {{word}}',
  'result.countOf': '{{total}} tadan {{count}} ta {{word}}',
  'result.matching': 'joriy filtrlarga mos',
  // ── "Bu raqam nimani bildiradi?" — tender soniga izoh (#41) ──
  'result.hint.gov':
    "Faqat {{country}} ochiq davlat xaridlari — faol va yopilayotganlari ko'rsatilgan. Yakunlangan va muddati o'tganlari hisobga kirmaydi. Katalog avtomatik yangilanadi.",
  'result.hint.ifi':
    "Xalqaro institutlar (Jahon banki, ADB va b.) moliyalashtiradigan loyihalar. Byudjet {{currency}}da e'lon qilinmaydi, shuning uchun summasiz ochiq e'lonlar ham hisobga kiradi.",
  'result.hint.corporate':
    "Kompaniyalarning o'z xaridlari (banklar, aviakompaniyalar). Faqat ularning portallaridagi ochiq e'lonlar ko'rsatilgan.",
  // ── Catalog header stat chips ──────────────────────────────────
  'catalog.chips.active': '{{count}} ta faol',
  'catalog.chips.closingWeek': '{{count}} ta tez yopiladi',
  'catalog.chips.newToday': '{{count}} ta yangi',
  'catalog.mySelection': "Sizning to'plamingiz: {{count}} ta {{lots}}",
  'catalog.spotlight.title': "Nima yetkazib berishingizni tanlang — mos tenderlarni ko'rsatamiz",
  'result.updated': 'Yangilanadi',
  'tgBanner.title': 'Tenderlarni Telegramda oling',
  'tgBanner.desc': "Saqlangan qidiruvlaringiz bo'yicha bildirishnomalar",
  'tgBanner.dismiss': 'Yashirish',
  'channelCta.title': "Telegram'da yirik tenderlar",
  'channelCta.desc': "Hafta g'oliblari va eng katta lotlar — har kuni",
  'channelCta.button': "Obuna bo'lish",
  // ── Pagination ─────────────────────────────────────────────────
  'pagination.showing': "{{total}} tadan {{from}}–{{to}} ko'rsatilmoqda",
  'pagination.prev': 'Orqaga',
  'pagination.next': 'Oldinga',
  // ── Upgrade banner / plans ─────────────────────────────────────
  'plans.eyebrow': 'Pro tariflari',
  'plans.title': "Buyurtmachilar kontaktlarini va ma'lumot eksportini oching",
  'plans.subtitle':
    "Buyurtmachilar kontaktlari, Excel'ga eksport, yangi tenderlar haqida Telegram bildirishnomalar.",
  'plans.cta': "Tariflarni ko'rish",
  'plans.dismiss': 'Keyinroq',
  // ── Plans / pricing page ───────────────────────────────────────
  'plans.pageTitle': 'Tariflar',
  'plans.seoTitle': 'Tariflar va narxlar — buyurtmachilar kontaktlariga kirish',
  'plans.seoDesc':
    "{{brand}} tariflari: Pro — oyiga 399 000 {{currency}}: buyurtmachilar kontaktlari, tender hujjatlari va {{country}} davlat xaridlari bo'yicha ma'lumot eksporti. Tavsif va talablarga kirish bepul.",
  'plans.pageLead':
    "Tenderlarni o'qish va tahlil qilish — bepul. Tarif buyurtmachi kontaktlari, hujjatlar va tahlilni ochadi — ishtirok etish uchun kerak bo'lgani.",
  'billing.autoRenew.title': 'Avtomatik uzaytirish',
  'billing.subscription.title': 'Sizning obunangiz',
  'billing.autoRenew.card': 'Saqlangan karta: {{pan}}',
  'billing.autoRenew.toggle': 'Obunani avtomatik uzaytirish',
  'billing.autoRenew.note':
    "Muddat tugaydigan kuni saqlangan kartadan tasdiqsiz yechib olinadi. Istalgan vaqtda o'chirish mumkin.",
  'billing.autoRenew.retention':
    "Uzaytirish yoqilgan ekan, bildirishnomalar va kontaktlar uzilmaydi, kartani qayta kiritish shart emas. O'chirish — bir bosish: tarif bir martalik bo'lib, {{date}}-da tugaydi.",
  'billing.autoRenew.notePaused':
    "Pauzadan keyin, {{date}}-da saqlangan kartadan yechib olinadi. Uzaytirishni istalgan vaqtda o'chirish mumkin — unda pauzadan keyin obuna qayta tiklanmaydi.",
  'billing.autoRenew.remove': "Kartani o'chirish",
  'billing.autoRenew.changeCard': "Kartani o'zgartirish",
  'billing.autoRenew.cancel': 'Obunani bekor qilish',
  'billing.autoRenew.nextCharge': "Keyingi to'lov: {{date}} · {{amount}}",
  'billing.autoRenew.nextChargeDate': "Keyingi to'lov: {{date}}",
  'billing.autoRenew.canceledUntil': 'Obuna {{date}}-gacha amal qiladi, uzaytirilmaydi.',
  'billing.autoRenew.canceled': "Avtomatik uzaytirish o'chirildi.",
  'billing.pause.running': "{{until}}-gacha pauza: kirish yopiq, to'lov {{until}}",
  'billing.pause.scheduled':
    "{{from}}-dan {{until}}-gacha pauza: kirish yopiladi, to'lov {{until}}",
  'billing.pause.resume': 'Hozir davom ettirish',
  'billing.pause.resumeNote':
    "Odatiy tarif bo'yicha bir-ikki soat ichida to'lov olinadi, kirish darhol ochiladi.",
  'billing.pause.cancel': 'Pauzani bekor qilish',
  'billing.autoRenew.declined':
    "To'lovni yechib bo'lmadi — avtomatik uzaytirishni davom ettirish uchun kartani yangilang.",
  'billing.autoRenew.updateCard': 'Kartani yangilash',
  // Obunani bekor qilish sababi (2026-09-21). Apostrof — ASCII (o'/g'),
  // shuning uchun tarkibida apostrof bor satrlar qo'sh tirnoqda.
  'churn.title.autoRenew': "Avtomatik uzaytirishni o'chirasizmi?",
  'churn.title.card': "Kartani o'chirasizmi?",
  'churn.why': 'Nega?',
  'churn.value': "Qidiruvlaringiz bo'yicha bir oyda {{n}} {{word}} keldi",
  'churn.confirm.autoRenew': "Uzaytirishni o'chirish",
  'churn.confirm.card': "Kartani o'chirish",
  'churn.pause': '1 oyga pauza — keyin eski narxda davom etadi',
  'churn.pauseNote': "Kirish {{from}} yopiladi, {{to}} gacha to'lov olinmaydi.",
  'churn.pauseNoteNoDate': "Kirish bir oyga yopiladi, to'lov olinmaydi.",
  'churn.pickReason': 'Sababni tanlang',
  'churn.detailsLabel': 'Batafsil (ixtiyoriy)',
  'churn.detailsRequired': 'Batafsil yozing',
  'churn.retain.noRelevantTenders':
    'Bizga Telegramda yozing — qidiruvni 10 daqiqada siz uchun sozlab beramiz',
  'churn.retain.poorAlerts': 'Qidiruvni toraytiramiz — Telegramda yozing',
  'churn.retain.changingCard':
    "Kartani o'chirish shart emas — yangisini ulang, eskisi almashtiriladi",
  'churn.reason.changingCard': 'Kartani almashtiryapman',
  'churn.reason.noCardStorage': 'Kartani saqlamoqchi emasman',
  'churn.reason.stopRenewing': 'Uzaytirmayman',
  'churn.reason.noRelevantTenders': "Mos tender yo'q",
  'churn.reason.didNotWin': 'Yuta olmadim',
  'churn.reason.noTime': "Vaqt yo'q",
  'churn.reason.foundBetter': 'Boshqa servis topdim',
  'churn.reason.tooExpensive': 'Qimmat',
  'churn.reason.oneOffNeed': 'Bir marta kerak edi',
  'churn.reason.poorAlerts': 'Foydali bildirishnoma kam',
  'churn.reason.hardToUse': 'Tushunish qiyin',
  'churn.reason.paymentIssue': "To'lov bilan muammo",
  'churn.reason.other': 'Boshqa',
  'billing.history.title': "To'lovlar tarixi",
  'billing.history.showAll': "Barchasini ko'rsatish ({{count}})",
  'billing.history.fiscalReceipt': 'Fiskal chek',
  'billing.history.status.completed': "To'landi",
  'billing.history.status.pending': "To'lov kutilmoqda",
  'billing.history.status.preparing': 'Qayta ishlanmoqda',
  'billing.history.status.cancelled': 'Bekor qilingan',
  'billing.autoRenew.addPrompt':
    "Obuna har safar qo'lda to'lovsiz avtomatik uzaytirilishi uchun kartani bog'lang.",
  'billing.autoRenew.addCard': "Kartani bog'lash",
  'billing.card.title': "Kartani bog'lash",
  'billing.card.titleSubscribe': 'Obunani rasmiylashtirish',
  'billing.card.subtitle':
    "Karta ma'lumotlari Payme tomonida qayta ishlanadi. Biz kartani saqlamaymiz.",
  'billing.card.subscribeSubtitle': "Kartani saqlamaymiz — ma'lumotlarni Payme qayta ishlaydi.",
  'billing.card.securedBy': "To'lov himoyalangan",
  'billing.card.planLabel': 'Tarif',
  'billing.card.chargeNowLabel': 'Hozir yechiladi',
  'billing.card.policyPrefix': 'Obunani rasmiylashtirib, siz',
  'billing.card.policyOffer': 'ofertani',
  // Qaytarilmaslik sharti checkoutdan olib tashlandi — u faqat ofertada
  // qoladi (content/legal.ts §5). Bu yerda gapni tugatuvchi fe'l qoladi:
  // o'zbek tilida u havoladan KEYIN keladi, shuning uchun kalit saqlanadi.
  'billing.card.renewLabel': 'Avtomatik uzaytirish',
  'billing.card.thenMonthly': 'har oy {{amount}}',
  'billing.card.thenYearly': 'har yili {{amount}}',
  'billing.card.upsellYear': "Yillikka o'tish — {{months}} oy bepul",
  'billing.card.pitchCategory':
    "Sizning yo'nalishingizda shu hafta {{count}} ta tender yopiladi — kontaktlar ichida",
  'billing.card.pitchMarket': 'Hozir {{count}} ta tender ochiq, {{sum}} {{currency}}ga',
  'billing.card.payAmount': "{{amount}} to'lash",
  'billing.card.nextChargeOn': "Keyingi to'lov — {{date}}.",
  'billing.card.remindTelegram': 'Telegramda eslatamiz.',
  'billing.card.remindEmail': 'Pochtaga eslatamiz.',
  'billing.card.cancelHow': "O'chirish — «Tariflar»da ikki marta bosish.",
  'billing.card.periodMonthly': 'oyiga',
  'billing.card.periodAnnual': 'yiliga',
  'billing.card.otpRecap': "{{card}} kartasidan {{amount}} to'lov",
  'billing.card.receiptPayme': 'Fiskal chek Payme ilovasiga keladi',
  'billing.card.receiptOcto': "Fiskal chek to'lovlar tarixida mavjud bo'ladi",
  // Dated renewal timeline shown in the subscribe modal.
  'billing.card.timelineToday': 'Bugun',
  'billing.card.timelineTodayText': '{{amount}}, kirish darhol ochiladi',
  'billing.card.timelineRemind': 'uzaytirish haqida pochtaga eslatma',
  'billing.card.timelineRemindTelegram': 'Telegramda eslatamiz',
  'billing.card.timelineRemindEmail': 'pochtaga eslatamiz',
  'billing.card.timelineRenew': 'uzaytirish',
  'billing.card.timelineToggle': "To'lov va uzaytirish",
  'billing.card.renewLine': 'Uzaytirish {{date}} kuni.',
  'billing.card.smsFromPayme': "SMS-kod Payme'dan, karta raqamini ko'rmaymiz",
  'billing.card.nicheOpen': "Sizning qidiruvlaringiz bo'yicha hozir {{count}} ta ochiq lot",
  'billing.card.nicheDirection':
    "Sizning qidiruvlaringiz bo'yicha har oy {{count}} ta yangi lot paydo bo'ladi",
  'billing.card.nicheDaily': "Har kuni {{count}} ta yangi lot paydo bo'ladi",
  'billing.card.securedByPay': "To'lov himoyalangan — Payme qayta ishlaydi",
  'billing.card.securedByOcto': "To'lov himoyalangan — Octobank qayta ishlaydi",
  'billing.card.refund7': '7 kunlik pulni qaytarish kafolati',
  'billing.card.securedByClick': "To'lov himoyalangan — Click qayta ishlaydi",
  'billing.card.securedByPayClick': "To'lov himoyalangan — Payme yoki Click qayta ishlaydi",
  'billing.card.supportTg': "Telegramda qo'llab-quvvatlash",
  'billing.card.offerLink': 'Oferta',
  'billing.card.privacyLink': 'Maxfiylik',
  'billing.card.cancelAnytime':
    'Avtomatik uzaytirishni istalgan vaqtda shaxsiy kabinetda bekor qilish mumkin.',
  'billing.card.nextHint': "Keyin Payme'dan SMS kod keladi.",
  'billing.card.policyAnd': 'va',
  'billing.card.policyPrivacy': 'maxfiylik siyosatini',
  'billing.card.policySuffix': ' qabul qilasiz.',
  'plans.subscribeWithCard': "{{name}}ga obuna bo'lish",
  'plans.payOnceLead': "To'lov Payme tomonida · kartani bizda kiritish shart emas",
  'plans.payOnceLeadVia': "To'lov {{gateway}} tomonida · kartani bizda kiritish shart emas",
  'plans.payOnceBtn': "Bir marta to'lash",
  'plans.cardOnlyCta': "Karta bilan to'lash",
  'plans.checkoutLinkFailed': "To'lov sahifasini ochib bo'lmadi. «To'lash» tugmasini yana bosing.",
  'plans.stripe.renews':
    "Obuna har oy uzaytiriladi. Uzaytirishni istalgan vaqtda shu yerda, tariflar sahifasida o'chirish mumkin.",
  'plans.stripe.alreadySubscribed':
    "Sizda uzaytiriladigan obuna allaqachon bor. Tarifni almashtirish uchun quyida avtomatik uzaytirishni o'chiring — to'langan davr saqlanadi — va yangisini rasmiylashtiring.",
  'plans.stripe.payee': "Karta orqali to'lovlarni Stripe orqali {{name}} (AQSh) qabul qiladi",
  'plans.stripe.secureNote': "Karta orqali to'lov himoyalangan va Stripe orqali o'tadi",
  'plans.stripe.inAppHint':
    "To'lov brauzerda ishonchliroq: bu sahifani Chrome yoki Safari'da oching",
  'plans.stripe.inAppOpen': 'Brauzerda ochish',
  'billing.stripe.payMonthly': "{{amount}} / oy to'lash",
  'billing.stripe.payAnnual': "{{amount}} / yil to'lash",
  'billing.stripe.loading': "To'lov shakli tayyorlanmoqda…",
  'billing.stripe.loadFailed':
    "To'lov shaklini ochib bo'lmadi. Oynani yopib, qaytadan urinib ko'ring.",
  'billing.stripe.errorFunds':
    "Kartada mablag' yetarli emas. Uni to'ldiring yoki boshqa kartani kiriting.",
  'billing.stripe.errorExpired': 'Karta muddati tugagan. Boshqa kartani kiriting.',
  'billing.stripe.errorCard': 'Karta raqami, amal qilish muddati va CVC kodini tekshiring.',
  'billing.stripe.error3ds':
    "Bank to'lovni tasdiqlamadi. Qaytadan urinib ko'ring yoki boshqa kartani kiriting.",
  'billing.stripe.errorDeclined':
    "Bank to'lovni rad etdi. Boshqa kartani sinab ko'ring yoki bankka murojaat qiling.",
  'billing.stripe.errorGeneric': "To'lov o'tmadi. Qaytadan urinib ko'ring.",
  'plans.cardOnlyPrice': '{{amount}} / oy',
  'plans.cardOnlyRenews':
    "Har oy avtomatik uzaytiriladi. Istalgan vaqtda shaxsiy kabinetda o'chirish mumkin.",
  'plans.onceSheetTitle': '{{name}} tarifi — 1 oy',
  'plans.onceSheetPick': "To'lov uchun ilovani tanlang",
  'plans.oncePayNow': "{{amount}} to'lash",
  'plans.oncePreparing': "To'lovni tayyorlayapmiz…",
  'plans.onceExternalHint': "To'lov telefon brauzerida ochiladi",
  'plans.handoffStuck': 'Ochilmadimi? Havolani telefon brauzerida oching',
  'plans.handoffCopy': 'Havolani nusxalash',
  'plans.handoffCopied': 'Nusxalandi',
  'plans.onceSheetClose': 'Yopish',
  'plans.onceTimelineTitle': "To'lov va kirish",
  'plans.onceAccessLine': '{{days}} kunga kirish, {{date}} gacha. Avtomatik uzaytirishsiz.',
  'plans.onceTimelineSub': '{{days}} kunlik kirish',
  'plans.onceTimelineToday': 'Bugun',
  'plans.onceTimelineTodayText': '{{amount}}, kirish darhol ochiladi',
  'plans.onceTimelineEnd': 'kirish tugaydi',
  // The static floor shown until the live number arrives — see the note on
  // the Russian key.
  'plans.social':
    '{{country}} Respublikasining 2 000 dan ortiq yetkazib beruvchisi allaqachon biz bilan',
  // The same sentence with the live number ({{count}} = «2 000»).
  'plans.socialLive':
    '{{country}} Respublikasining {{count}} dan ortiq yetkazib beruvchisi allaqachon biz bilan',
  // Uzbek is invariant — {{word}} is ignored here.
  'plans.openNow': 'Hozir {{count}} ta ochiq tender',
  'plans.group.search': 'Qidiruv',
  'plans.group.contacts': 'Kontaktlar',
  'plans.group.analysis': 'Tahlil',
  'plans.business.plus': "Pro'dagi hammasi, plyus:",
  'plans.octo.title': 'Obunani rasmiylashtirish',
  'plans.octo.tabOcto': 'Octobank',
  'plans.octo.tabPayme': 'Payme',
  'plans.octo.continue': "Octobank'da davom etish",
  'plans.octo.redirectNote': "Karta ma'lumotlari Octobank himoyalangan sahifasida kiritiladi",
  'plans.octo.error': "To'lovni boshlab bo'lmadi. Yana urinib ko'ring.",
  'plans.accessUntil':
    "Ma'lumotlar tahliliga kirish to'lovdan so'ng faollashadi, {{date}}-gacha · istalgan vaqtda bekor qilish mumkin",
  'plans.cantPay': "To'lay olmayapsizmi?",
  // Checkout reassurance strip on /plans — answers the objections a buyer has
  // before clicking pay (card safety, surprise charges, legitimacy).
  'plans.trust.secureTitle': "Xavfsiz to'lov",
  'plans.trust.secureText':
    "Kartani Payme, Click va Octobank qayta ishlaydi — biz uning raqamini ko'rmaymiz va saqlamaymiz",
  'plans.trust.noSurpriseTitle': "Yashirin to'lovlarsiz",
  'plans.trust.noSurpriseText':
    "Bir marta to'lash mumkin. Avtomatik uzaytirish — ixtiyoriy, eslatma bilan va istalgan vaqtda bekor qilinadi",
  'plans.trust.refundTitle': 'Qaytarish kafolati',
  'plans.trust.refundText':
    "Birinchi to'lov yoqmadimi? 7 kun ichida bizga yozing — pulni qaytaramiz",
  'plans.trust.receiptTitle': 'Rasmiy chek',
  'plans.trust.receiptText': "To'lovdan so'ng rasmiy fiskal chek keladi",
  'billing.card.smsFrom':
    "Kod bilan SMS Payme'dan keladi ({{brand}}'dan emas), kartaga bog'langan raqamga.",
  // OTP bosqichida doim ko'rinadi — ikkita SMS kelganda qaysi kod
  // tekshirilayotgani bilinmaydi (23.09.2026 kuzatilgan).
  'billing.card.otpUseLast': "Oxirgi SMS'dagi kodni kiriting",
  'billing.card.resendIn': 'Kodni qayta yuborish {{time}}-dan keyin',
  'billing.card.resend': 'Kodni qayta yuborish',
  'billing.card.errorResend': "Kodni yuborib bo'lmadi. Qayta urinib ko'ring.",
  'billing.card.otpSubtitle': "Payme'dan kelgan SMS kodini kiriting.",
  'billing.card.otpTitle': "To'lovni tasdiqlang",
  'billing.card.otpBack': 'Orqaga',
  'billing.card.otpDigit': 'Raqam {{n}}',
  'billing.card.stepCard': 'Karta',
  'billing.card.stepCode': 'SMS kodi',
  'billing.card.stepAccess': 'Kirish ochildi',
  'billing.card.smsSentTo': 'Payme kod bilan SMSni {{phone}} raqamiga yubordi.',
  'billing.card.smsSentGeneric': "Payme kod bilan SMSni kartaga bog'langan raqamga yubordi.",
  'billing.card.otpChargeLine': '{{scheme}} {{card}} · {{amount}} yechiladi',
  'billing.card.confirmPay': "To'lovni tasdiqlash",
  'billing.card.otpFraud': "Kodni hech kimga aytmang — {{brand}} xodimlari uni so'ramaydi.",
  'billing.card.number': 'Karta raqami',
  'billing.card.expire': 'Muddat',
  // Latin, as it is embossed on the card itself — not the Russian «ММ/ГГ».
  'billing.card.expirePlaceholder': 'MM/YY',
  'billing.card.otp': 'SMS kodi',
  'billing.card.next': 'Keyingi',
  'billing.card.confirm': 'Tasdiqlash',
  'billing.card.errorCard': "Kartani bog'lab bo'lmadi. Raqam va muddatni tekshiring.",
  'billing.card.errorCardNotAccepted':
    "Karta raqami va muddatini tekshiring. Hammasi to'g'ri bo'lsa — bir daqiqadan so'ng qayta urinib ko'ring yoki boshqa kartani kiriting.",
  'billing.card.errorTinRequired':
    "Bu tarif uchun kompaniya STIRi kerak. Uni sozlamalarda kiriting va to'lovni qaytadan amalga oshiring — SMS kodi bilan bog'liq emas.",
  'billing.card.errorOtp': "Kod noto'g'ri. Qayta urinib ko'ring.",
  'billing.card.errorChargeFailed':
    "Bank bu kartadan to'lovni rad etdi. Boshqa kartani sinab ko'ring.",
  'billing.card.errorInsufficientFunds':
    "Kartada mablag' yetarli emas. Kartani to'ldiring yoki boshqasidan foydalaning.",
  'billing.card.errorCardNotFound': 'Bunday raqamli karta topilmadi. Raqamni tekshiring.',
  'billing.card.errorCorporateCard':
    "Bu korporativ karta — Payme uni qabul qilmaydi. Boshqa kartadan foydalaning yoki Octobank orqali to'lang.",
  'billing.card.errorCardBlocked': 'Karta bank tomonidan bloklangan. Boshqa kartadan foydalaning.',
  'billing.card.errorCardExpired': 'Karta muddati tugagan. Boshqa kartadan foydalaning.',
  'billing.card.errorSmsNotEnabled':
    'Kartada SMS-xabarnoma yoqilmagan. Uni bankda yoqing yoki boshqa kartadan foydalaning.',
  'billing.card.errorWrongExpiry': "Amal qilish muddati noto'g'ri. Oy va yilni tekshiring.",
  'billing.card.errorWrongNumber': "Karta raqami noto'g'ri. Raqamni tekshiring.",
  'billing.card.errorCardNotServed':
    "Bu karta onlayn to'lov uchun mos emas. Boshqasidan foydalaning.",
  'billing.card.errorLimitExceeded': 'Kartaning oylik limiti tugagan. Boshqa kartadan foydalaning.',
  'billing.card.errorCurrency': "Karta valyutasi mos emas. So'mdagi karta kerak.",
  'billing.card.errorProcessingUnavailable':
    "Bank vaqtincha ishlamayapti. Bir necha daqiqadan so'ng urinib ko'ring.",
  'billing.card.errorOtpExpired': "Kod muddati tugadi. Yangisini so'rang.",
  'billing.card.errorOtpAttempts': "Urinishlar tugadi. Yangi kod so'rang.",
  'billing.card.errorEmpty': 'Karta raqamini kiriting',
  'billing.card.errorExpireEmpty': 'Muddatni kiriting',
  'billing.card.errorIncomplete': 'Karta raqamining 16 raqamini kiriting',
  'billing.card.errorInvalidNumber': "Karta raqami noto'g'ri kiritilgan",
  'billing.card.errorUnsupported':
    "Bunday karta qo'llab-quvvatlanmaydi. Raqamni tekshiring: Uzcard, Humo, Visa va Mastercard qabul qilinadi.",
  'billing.card.errorPaymeBrandUnsupported':
    "Bu karta avtomatik to'lov uchun mos emas. Bir martalik to'lov qiling — tarifda «Bir marta to'lash» tugmasi.",
  'billing.card.errorUnsupportedOcto':
    "Bu karta Payme orqali qo'llab-quvvatlanmaydi. Octobank orqali to'lang — u Visa va Mastercardni qabul qiladi.",
  'billing.card.payViaOcto': "Octobank orqali to'lash",
  'billing.card.foreignBrandHint': 'Payme faqat Uzcard va Humo kartalarini qabul qiladi.',
  'billing.card.corporateOcto': 'Payme korporativ kartalarni qabul qilmaydi.',
  'billing.card.errorExpired': 'Amal qilish muddati tugagan',
  'billing.card.errorExpireInvalid': "Muddat noto'g'ri",
  'plans.perYear': '/ yil',
  'plans.periodMonth': 'oy',
  'plans.periodYear': 'yil',
  'plans.perMonth': '/ oy',
  'plans.from': '…dan boshlab',
  'plans.tiersCount': '{{count}} ta tarif',
  'plans.bannerYear': 'Yil — 6 oy narxiga',
  'plans.bannerPair': 'Pro va Biznes · oy yoki yil',
  // Plan names, per locale. The DB holds one Russian label per plan and the
  // Uzbek page rendered it verbatim; keyed by plan-key FAMILY so pro-monthly
  // and pro-yearly share one entry. «YaTT» = yakka tartibdagi tadbirkor, the
  // Uzbek for ИП.
  'plans.name.pro': 'Pro',
  'plans.name.business': 'Biznes',
  'plans.name.ip': 'YaTT',
  'plans.name.free': 'Start',
  'plans.som': '{{currency}}',
  'plans.feature.opens': 'Oyiga {{count}} ta kontakt ochish',
  'plans.feature.categoryLimit': '{{count}} tagacha toifa',
  'plans.feature.categoryLimitUnlimited': 'Cheksiz YeNKT toifalari',
  'plans.feature.categoryNiche': "1 ta YeNKT yo'nalishi + Telegram-bildirishnoma",
  'plans.feature.contactsNiche': 'Davlat xaridlari katalogi',
  'plans.feature.allTenders': '{{country}} Respublikasining barcha tenderlari (35+ manba)',
  'plans.feature.privateTenders': 'Xususiy tenderlar: banklar, telekom va yirik kompaniyalar',
  'plans.feature.ifi': 'XMI tenderlari: Jahon banki, ADB, BMT',
  'plans.feature.contactsMetered': 'Oyiga {{count}} ta buyurtmachi kontakti',
  'plans.feature.budgetCeiling': "Byudjeti {{amount}} mln {{currency}}gacha bo'lgan tenderlar",
  'plans.feature.contactsAll': 'Barcha buyurtmachi kontaktlari — cheksiz',
  'plans.feature.winnerContacts': "O'tgan tenderlar g'oliblarining kontaktlari — telefon va pochta",
  'plans.feature.documents': 'Tender hujjatlari (TT, spetsifikatsiyalar)',
  'plans.feature.procedure': "Protsedura o'tkazish tartibi",
  'plans.feature.aiSummary': 'TT tahlili va talablar — bepul',
  'plans.feature.aiSummaryFull': "TT to'liq tahlili va talablari (UZ/RU)",
  'plans.feature.savedSearchOne': '3 tagacha saqlangan qidiruv + Telegram bildirishnoma',
  'plans.feature.savedSearchAll': 'Cheksiz saqlangan qidiruv + bildirishnomalar',
  'plans.feature.supplierProfile':
    "Yutgan tenderlaringiz bo'yicha profil — sozlashsiz bildirishnomalar",
  'plans.feature.telegramBot':
    'Telegram-bot: qidiruv, AI-javoblar, dayjestlar, obunalarni boshqarish',
  'plans.feature.export': 'Excelga eksport',
  'plans.feature.buyerAnalytics':
    'Buyurtmachilar tahlili: kim bilan ishlaydi, xaridlar konsentratsiyasi va yillik hajmi',
  'plans.feature.analytics': "Har bir tender bo'yicha g'olib narxlari va bazaviy stavkalar",
  'plans.feature.orgWatch':
    'Buyurtmachi va raqobatchilarni kuzatish (50 ta) — yangi shartnomalar haqida bildirishnomalar',
  'plans.feature.prioritySupport': "Ustuvor qo'llab-quvvatlash",
  'plans.business.seats': "Jamoada {{count}} ta o'rin: siz va xodimlaringiz",
  'plans.business.seatsGeneric': "Jamoa uchun bir nechta o'rin",
  'plans.business.telegram': "Har bir xodimning o'z Telegram-boti va o'z bildirishnomalari",
  'baseRates.title': "Bozor ma'lumotlari",
  'baseRates.hint':
    "Shu toifadagi va shu lotga yaqin hajmdagi (lot byudjetining 0,3 barobaridan 3 barobarigacha) yakunlangan xaridlar bo'yicha boshlang'ich narxdan chegirma mediani, ishtirokchilar soni va g'olib narx oralig'i. Raqobat va adolatli narxni baholashga yordam beradi.",
  'baseRates.competition': 'Ishtirokchilar medianasi',
  'baseRates.discount': 'Median chegirma',
  // Chegirma — panelning asosiy raqami: u har qanday hajmdagi lotlar uchun
  // taqqoslanadi, mutlaq narx esa yo'q.
  'baseRates.discountCaption': "G'oliblar boshlang'ich narxdan qancha tushgani",
  'baseRates.degenerate':
    "{{pct}}% xarid bir xil qiymatda — bu maydon qoidasi, bozor ko'rsatkichi emas",
  'baseRates.priceBand': "G'olib narx oralig'i",
  'baseRates.priceMedian': "G'olib narx mediani",
  'baseRates.priceBasisBanded': "Shu hajmdagi taqqoslanadigan xaridlar bo'yicha median",
  'baseRates.priceBasisSection': "Butun toifa bo'yicha median — lot hajmi hisobga olinmagan",
  'baseRates.basisBanded':
    "{{n}} ta taqqoslanadigan xarid bo'yicha: g'olib narx {{min}} – {{max}}, {{from}} – {{to}}",
  'baseRates.basisBandedNoDates':
    "{{n}} ta taqqoslanadigan xarid bo'yicha: g'olib narx {{min}} – {{max}}",
  'baseRates.basisSection': "Toifadagi {{n}} ta xarid bo'yicha, {{from}} – {{to}}",
  'baseRates.basisSectionNoDates': "Toifadagi {{n}} ta xarid bo'yicha",
  'baseRates.teaserBasis': "{{period}} ichidagi {{n}} ta taqqoslanadigan xarid bo'yicha",
  'baseRates.teaserBasisNoDates': "{{n}} ta taqqoslanadigan xarid bo'yicha",
  // O'zbekchada son bilan ot kelishmaydi — uchala shakl ham bir xil.
  'baseRates.teaserMonths.one': '{{n}} oy',
  'baseRates.teaserMonths.few': '{{n}} oy',
  'baseRates.teaserMonths.many': '{{n}} oy',
  'baseRates.sizeBlind':
    "Lotning byudjeti ko'rsatilmagan, shuning uchun taqqoslash butun toifa bo'yicha olib borilgan va lot hajmini hisobga olmaydi.",
  'baseRates.positionBelow': "Lot byudjeti shunday xaridlardagi odatdagi g'olib narxdan past",
  'baseRates.positionInside': "Lot byudjeti g'olib narxlarning odatdagi oralig'ida",
  'baseRates.positionAbove': "Lot byudjeti shunday xaridlardagi odatdagi g'olib narxdan yuqori",
  'baseRates.insufficient': "Bu toifa bo'yicha hali ma'lumot yetarli emas",
  'baseRates.locked': 'Analitika Pro tarifida',
  'baseRates.lockedCta': "Tariflarni ko'rish",
  // ── Price reference (#46) ──────────────────────────────────────
  // ── Market dashboard ───────────────────────────────────────────
  'market.title': '{{country}} davlat xaridlari bozori',
  'market.subtitle':
    'Ochiq tenderlar va xarid natijalari raqamlarda: byudjetlar, hududlar, sohalar va dinamika.',
  'market.summary':
    "Hozir {{countryGen}} {{active}} ta ochiq davlat tenderi bor, umumiy summasi {{budget}}; so'nggi haftada {{newWeek}} ta qo'shildi. Quyida byudjetning hududlar va sohalar bo'yicha taqsimoti hamda yakunlangan xaridlar natijalari.",
  'market.seo.title': '{{country}} davlat xaridlari bozori — statistika va tahlil',
  'market.seo.description':
    "{{country}} davlat xaridlari bozori tahlili: qancha tender ochiq, hududlar va sohalar bo'yicha byudjetlar, xarid natijalari hajmi va raqobati.",
  'market.som': '{{currency}}',
  'market.count': '{{count}} ta xarid',
  'market.generatedAt': "Ma'lumotlar {{date}} holatiga",
  'market.kpi.active': 'Faol tenderlar',
  'market.kpi.budget': 'Bozordagi byudjet',
  'market.kpi.newWeek': 'Bir haftada yangi',
  'market.kpi.closingSoon': 'Tez yopiladi',
  'market.kpi.awardedCount': 'Yil davomidagi xaridlar',
  'market.kpi.awardedVolume': 'Yillik hajm',
  'market.byRegion': "Hududlar bo'yicha byudjet",
  'market.byCategory': "Toifalar bo'yicha byudjet",
  'market.newPerWeek': "Haftalar bo'yicha yangi tenderlar",
  'market.awardedByYear': "Yillar bo'yicha xaridlar",
  'chart.noData': "ma'lumot yo'q",
  'market.competition': "Sohalar bo'yicha ishtirokchilar medianasi",
  'market.discount': "Sohalar bo'yicha median chegirma",
  'market.range.from': 'Sanadan',
  'market.range.to': 'Sanagacha',
  'market.range.reset': 'Davrni tozalash',
  'nav.market': 'Bozor',
  'prices.title': 'Tovar narxlari',
  'prices.subtitle': "Davlat tovar toifasi uchun o'rtacha qancha to'laydi",
  // See the ru.ts note. ⚠️ «shartnoma narxi» (contract price), never a unit price.
  // See the ru.ts note: no product code in these — it truncated off the tail.
  'prices.seoTitle': '{{name}} — davlat xaridlari narxlari',
  'prices.seoDesc.bandDated':
    "«{{name}}» shartnomasining median narxi — {{median}} {{currency}}, oralig'i {{p25}}–{{p75}}. {{from}}–{{to}}: {{countryGen}} {{n}} ta yakunlangan xaridi.",
  'prices.seoDesc.band':
    "«{{name}}» shartnomasining median narxi — {{median}} {{currency}}, oralig'i {{p25}}–{{p75}}. {{countryGen}} {{n}} ta yakunlangan xaridi bo'yicha.",
  'prices.seoDesc.sample':
    "«{{name}}» bo'yicha {{countryPrep}} yakunlangan davlat xaridlari statistikasi: {{n}} ta xarid tanlanmasi.",
  'prices.seoDesc.empty':
    "Davlat «{{name}}» uchun qancha to'laydi — {{countryGen}} yakunlangan davlat xaridlari ma'lumotlari.",
  'prices.search': "Tovar yoki kod bo'yicha qidiruv",
  'prices.count': '{{count}} ta xarid',
  'prices.empty': "Hozircha yetarli xarid tarixiga ega toifalar yo'q.",
  'prices.back': '← Tovarlarga',
  'prices.locked': 'Narx tahlili Pro tarifida mavjud.',
  'prices.locked.cta': "Pro'ni ochish",
  'prices.insufficient': "Bu toifa bo'yicha statistika uchun yakunlangan xaridlar hali kam.",
  'prices.parentFallback':
    "{{code}} kodi bo'yicha yakunlangan xaridlar hali yo'q — kengroq «{{name}}» toifasi narxlari ko'rsatilmoqda.",
  'prices.band': "G'olib narxi",
  'prices.band.p25': '25% — past',
  'prices.band.median': 'mediana',
  'prices.band.p75': '75% — yuqori',
  'prices.discount': "Boshlang'ich narxdan median chegirma",
  'prices.basedOn': "tanlanmadagi boshlang'ich narxi e'lon qilingan {{n}} ta xarid asosida",
  'prices.discountUnknown':
    "ma'lumot yo'q: manba boshlang'ich narxni yakuniy narx sifatida yozadi ({{n}} ta xarid)",
  'prices.noSourceData': "manba bu ma'lumotlarni e'lon qilmaydi",
  'prices.sampleNoDates': "Tanlanma: {{n}} ta xarid · manba sanalarni e'lon qilmaydi",
  'prices.sortBy': 'Saralash:',
  'prices.sortCount': "Ma'lumot hajmi bo'yicha",
  'prices.sortName': "Nom bo'yicha",
  'prices.participants': 'Ishtirokchilar medianasi',
  'prices.sample': 'Tanlanma: {{n}} ta xarid · {{from}}–{{to}}',
  'prices.caveat': "Toifa bo'yicha shartnoma qiymati ko'rsatilgan, tovar birligi narxi emas.",
  'nav.prices': 'Narxlar',
  'nav.results': 'Natijalar',
  'baseRates.pricesLink': "Toifa bo'yicha to'liq narx tarixi →",
  'similarWinners.title': 'Bunday lotlarni kim yutadi',
  'similarWinners.hint':
    "Oxirgi 24 oyda xuddi shu YeNKT kodi bo'yicha xaridlarda g'olib bo'lgan kompaniyalar. Aniq kod bo'yicha g'oliblar uchtadan kam bo'lsa — kod sinfi (dastlabki 6 raqam) bo'yicha. Ulush — g'alabalar ulushi.",
  'similarWinners.teaserBasis': '24 oyda {{awards}} · {{winners}}',
  'similarWinners.teaserCompanyN': 'Kompaniya № {{n}}',
  'similarWinners.share': "G'alabalar ulushi",
  'similarWinners.basisExact': 'YeNKT kodi {{code}}: 24 oyda {{awards}}, {{winners}}',
  'similarWinners.basisClass':
    "YeNKT sinfi {{code}} — aniq kod bo'yicha g'oliblar kam: 24 oyda {{awards}}, {{winners}}",
  'similarWinners.wins.one': "{{n}} ta g'alaba",
  'similarWinners.wins.few': "{{n}} ta g'alaba",
  'similarWinners.wins.many': "{{n}} ta g'alaba",
  'similarWinners.companies.one': '{{n}} ta kompaniya',
  'similarWinners.companies.few': '{{n}} ta kompaniya',
  'similarWinners.companies.many': '{{n}} ta kompaniya',
  'supplierGraph.title': 'Buyurtmachining yetkazib beruvchilari konsentratsiyasi',
  'supplierGraph.hint':
    "Ushbu buyurtmachining xaridlari nechta yetkazib beruvchida jamlangani va yangi ishtirokchiga kirish osonmi. Shartnomalar qancha kam bo'lsa, xulosa shuncha ehtiyotkor: 10 tagacha u taxminiy, 5 tagacha esa yo'q — faqat raqamlar. Tanlovsiz to'g'ridan-to'g'ri shartnomalar hisobga olinmaydi.",
  'supplierGraph.teaserSuppliers': "G'oliblar va ulushlari",
  'supplierGraph.teaserConcentration': 'Konsentratsiya',
  'supplierGraph.teaserSupplierN': 'Yetkazib beruvchi № {{n}}',
  'supplierGraph.teaserBasis': 'Buyurtmachi tarixida {{contracts}} · {{suppliers}}',
  'supplierProfile.title': 'Yetkazib beruvchi profili',
  'supplierProfile.back': '← Orqaga',
  'supplierProfile.locked': 'Yetkazib beruvchilar profillari Pro tarifida mavjud.',
  'supplierProfile.lockedCta': "Pro'ga o'tish",
  'supplierProfile.empty': "Bu yetkazib beruvchi bo'yicha hozircha ma'lumot yo'q.",
  'supplierProfile.contracts': 'Shartnomalar',
  'supplierProfile.totalValue': 'Shartnomalar summasi',
  'supplierProfile.avgValue': "O'rtacha shartnoma",
  'supplierProfile.buyers': 'Buyurtmachilar',
  'supplierProfile.tenure': 'Bozorda',
  'supplierProfile.tenureUnknown': "manba xarid sanalarini e'lon qilmaydi",
  'supplierProfile.p12.title': "So'nggi 12 oydagi davlat xaridlari",
  'supplierProfile.p12.wins': 'Yutilgan shartnomalar',
  'supplierProfile.p12.value': 'Shartnomalar summasi',
  'supplierProfile.p12.discount': "Boshlang'ich narxdan median chegirma",
  'supplierProfile.p12.discountNote': "boshlang'ich narxi ma'lum {{n}} ta shartnoma bo'yicha",
  'supplierProfile.p12.participants': 'Yutilgan lotlarda ishtirokchilar medianasi',
  'supplierProfile.p12.bids': 'Tafsilotli ishtirok',
  'supplierProfile.p12.bidsNote':
    "manba barcha ishtirokchilarni e'lon qilgan {{n}} ta lotdan {{wins}} ta g'alaba; to'liq ishtirok ulushi noma'lum",
  'supplierProfile.p12.source':
    "{{brand}} bazasidagi davlat xaridlari natijalari bo'yicha, g'olib aniqlangan sana so'nggi 12 oy ichida.",
  'supplierProfile.topBuyers': 'Asosiy buyurtmachilar',
  'supplierProfile.categories': 'Toifalar',
  'supplierProfile.recentContracts': "So'nggi shartnomalar",
  'supplierProfile.allContracts': 'Shartnomalar',
  'supplierProfile.contractsMore': "Yana ko'rsatish",
  'supplierProfile.regions': 'Hududlar',
  'supplierProfile.debarred': 'Ishonchsiz yetkazib beruvchilar reyestrida',
  'supplierProfile.nContracts': '{{n}} ta shartnoma',
  'buyer.title': 'Buyurtmachi profili',
  'buyer.back': '← Orqaga',
  'buyer.locked':
    "Bu buyurtmachining yetkazib beruvchilari, ulushlar va takroriy g'oliblar — Pro tarifida.",
  'buyer.lockedCta': "Pro'ni rasmiylashtirish",
  'buyer.tin': 'STIR',
  // «ИНН», not «STIR», on purpose: these spots printed a hard-coded «ИНН» in
  // both languages before the key existed, and the Uzbek pages must not change
  // with a Kazakhstan fix. Switching them to STIR is its own decision.
  'org.tinNumber': 'ИНН {{number}}',
  // STIR (= ИНН) in the title — see the ru catalogue for the GSC numbers.
  'buyer.seoTitle': '«{{name}}» — STIR {{tin}}: buyurtmachi xaridlari',
  'buyer.seoDescription':
    '{{name}}, STIR {{tin}} — {{awards}} ta shartnoma, {{value}}, {{suppliers}} ta yetkazib beruvchi, {{active}} ta faol tender. Toifalar va summalar — {{brand}}.',
  'supplier.seoTitle': '«{{name}}» — STIR {{tin}}: davlat shartnomalari',
  'supplier.seoDescription':
    '{{name}}, STIR {{tin}} — {{contracts}} ta davlat shartnomasi, {{value}}, {{buyers}} ta buyurtmachi, {{period}}. Toifalar va hududlar — {{brand}}.',
  'buyer.empty': "Bu buyurtmachi bo'yicha hozircha ma'lumot yo'q.",
  'buyer.dependenceFlag': "Bitta yetkazib beruvchiga bog'liqlik — xarajatlarning {{pct}}%",
  'buyer.kpi.awards': 'Shartnomalar',
  'buyer.kpi.value': 'Shartnomalar summasi',
  'buyer.kpi.suppliers': 'Yetkazib beruvchilar',
  'buyer.kpi.active': 'Faol tenderlar',
  'buyer.p12.title': "So'nggi 12 oydagi xaridlar",
  'buyer.p12.awards': "G'olib aniqlangan lotlar",
  'buyer.p12.value': 'Shartnomalar summasi',
  'buyer.p12.discount': "Boshlang'ich narxdan median chegirma",
  'buyer.p12.discountNote': "boshlang'ich narxi ma'lum {{n}} ta lot bo'yicha",
  'buyer.p12.participants': 'Ishtirokchilar medianasi',
  'buyer.p12.participantsNote': "ishtirokchilar soni ma'lum {{n}} ta lot bo'yicha",
  'buyer.p12.singleBidder': 'Bitta ishtirokchili lotlar',
  'buyer.p12.source':
    "{{brand}} bazasidagi davlat xaridlari natijalari bo'yicha, g'olib aniqlangan sana so'nggi 12 oy ichida.",
  // Settlement delta — see the ru file for why there are two labels.
  'buyer.settlement.below': 'Shartnoma taklifdan past',
  'buyer.settlement.above': 'Shartnoma taklifdan yuqori',
  'buyer.settlement.sub': "{{n}} ta shartnoma bo'yicha · {{pct}}% pastroq",
  'buyer.settlement.source': 'Manba: xarid.imv.uz',
  'buyer.favoritism': 'Konsentratsiya va favoritizm',
  'buyer.topShareSplit':
    'Top yetkazib beruvchi: summaning {{value}}% · shartnomalarning {{count}}%',
  'buyer.streak': "{{name}} ketma-ket {{n}} marta g'olib bo'ldi",
  'buyer.winnerSub': "{{wins}} g'alaba · summaning {{value}}% / shartnomalarning {{count}}%",
  'buyer.awardsByYear': "Yillar bo'yicha xaridlar",
  'buyer.categories': 'Toifalar',
  'buyer.recentAwards': "So'nggi shartnomalar",
  'buyer.recentTenders': "So'nggi tenderlar",
  'buyer.viewProfile': 'Buyurtmachi profili',
  'supplierGraph.topShare': 'Top yetkazib beruvchi ulushi',
  'supplierGraph.topShareBasis': '{{total}} shartnomadan {{wins}} tasi',
  'supplierGraph.locked': 'Analitika Pro tarifida',
  'supplierGraph.lockedCta': "Tariflarni ko'rish",
  'supplierGraph.insufficient': "Bu buyurtmachi bo'yicha hali ma'lumot yetarli emas",
  'supplierGraph.concentration.high': 'Xaridlar 1–2 yetkazib beruvchida',
  'supplierGraph.concentration.moderate': 'Doimiy yetkazib beruvchilar bor',
  'supplierGraph.concentration.low': 'Yetkazib beruvchilar almashib turadi',
  'supplierGraph.concentrationHint.high': 'Yangi ishtirokchiga kirish qiyin',
  'supplierGraph.concentrationHint.moderate': 'Kirish mumkin, lekin doimiy raqobatchilar bor',
  'supplierGraph.concentrationHint.low': 'Yangi ishtirokchiga kirish oson',
  'supplierGraph.tooEarly': '{{contracts}} — konsentratsiya haqida gapirish erta',
  'supplierGraph.concentrationHedged.high': 'Xaridlar 1–2 yetkazib beruvchida · {{contracts}}',
  'supplierGraph.concentrationHedged.moderate': 'Doimiy yetkazib beruvchilar bor · {{contracts}}',
  'supplierGraph.concentrationHedged.low': 'Yetkazib beruvchilar almashib turadi · {{contracts}}',
  'supplierGraph.hhiTitle': 'Konsentratsiya indeksi HHI {{n}}',
  'supplierGraph.dependenceFlag': "Bitta yetkazib beruvchiga yuqori bog'liqlik",
  'supplierGraph.contracts.one': '{{n}} ta shartnoma',
  'supplierGraph.contracts.few': '{{n}} ta shartnoma',
  'supplierGraph.contracts.many': '{{n}} ta shartnoma',
  'supplierGraph.suppliers.one': '{{n}} ta yetkazib beruvchi',
  'supplierGraph.suppliers.few': '{{n}} ta yetkazib beruvchi',
  'supplierGraph.suppliers.many': '{{n}} ta yetkazib beruvchi',
  'supplierGraph.top3Share': 'Top-3 ulushi',
  'supplierGraph.suppliersBasis': '{{n}} yetkazib beruvchidan',
  'supplierGraph.marketShare': 'Buyurtmachi bozor ulushi',
  'supplierGraph.topNShare': 'top-{{n}} · {{pct}}%',
  'supplierGraph.footer':
    '{{suppliers}} ta yetkazib beruvchi · {{contracts}} ta shartnoma · {{total}} {{currency}}',
  // Soliq registry trust strip — «Buyurtmachi haqida». Rendered on tender-detail
  // (near the buyer/contact area) and on the public buyer profile header.
  'tender.trust.title': 'Buyurtmachi haqida',
  'tender.trust.titleSupplier': 'Yetkazib beruvchi haqida',
  'tender.trust.vat': "QQS to'lovchisi",
  'tender.trust.fund': 'Ustav fondi',
  'tender.trust.since': '{{year}} yildan beri faoliyatda',
  'tender.trust.statusLabel': 'Holati',
  'tender.trust.vatLabel': 'QQS',
  'tender.trust.vatYes': "To'lovchi",
  'tender.trust.sinceLabel': 'Faoliyat boshlagan',
  'tender.trust.status.ACTIVE': 'Faoliyatda, soliq majburiyatlari bor',
  'tender.trust.status.TAX_FREE': "Soliq majburiyatlari yo'q",
  'tender.trust.status.INACTIVE': 'Tugatilish jarayonida',
  'tender.trust.status.LIQUIDATED': "Faoliyati to'xtatilgan",
  'tender.trust.liquidated': 'Tugatilgan',
  'tender.trust.kgd.DEBTOR_BANKRUPT': 'Sud qarori bilan bankrot deb topilgan',
  'tender.trust.kgd.DEBTOR_REHABILITATION': 'Sud qarori bilan sanatsiya jarayoni',
  'tender.trust.kgd.DEBTOR_LIQUIDATION_NO_BANKRUPTCY': 'Sud qarori bilan bankrotliksiz tugatish',
  'tender.trust.kgd.BANKRUPT': "KGD bankrotlar ro'yxatida",
  'tender.trust.kgd.PSEUDO_ENTERPRISE': 'Soxta korxona deb topilgan',
  'tender.trust.kgd.REGISTRATION_INVALID': "Ro'yxatdan o'tish haqiqiy emas deb topilgan",
  'tender.trust.kgd.REREGISTRATION_INVALID': "Qayta ro'yxatdan o'tish haqiqiy emas deb topilgan",
  'tender.trust.kgdSource': "Qozog'iston Davlat daromadlari qo'mitasi ma'lumotlariga ko'ra",
  // DXMAP davlat reytingi (xarid.icppa.uz). Faqat harf: ball 0-100 bo'lsa ham,
  // manba harflar orasidagi chegaralarni e'lon qilmaydi. Litsenziya manbani
  // ko'rsatishni talab qiladi.
  'tender.trust.dxmapRatingLabel': 'Barqarorlik reytingi',
  'tender.trust.dxmapSectorLabel': 'Faoliyat turi',
  'tender.trust.dxmapSource': "Soliq qo'mitasining barqarorlik reytingi, manba —",
  'requirements.title': 'Xarid talablari',
  'requirements.scope': 'Xarid predmeti',
  'requirements.qualifications': 'Malaka talablari',
  'requirements.technicalSpecs': 'Texnik xususiyatlar',
  'requirements.delivery': 'Yetkazib berish muddati',
  'requirements.warranty': 'Kafolat',
  'requirements.payment': "To'lov shartlari",
  // ⚠️ ASCII apostrophe only — apps/web/src/i18n/uz-apostrophes.test.ts enforces it
  // (deployment-wide standard since 2026-09-21, matching the shared `so'm`).
  'requirements.sourceDocuments': "lot hujjatlari bo'yicha",
  'requirements.sourceMarketplace': "{{name}} maydonchasi ma'lumotlari bo'yicha",
  // Maydoncha nomi — Pro qismi (2026-10-05): Pro'siz imzo uni nomlamaydi.
  'requirements.sourceMarketplaceGeneric': "manba maydonchasi ma'lumotlari bo'yicha",
  'requirements.disqualifying': 'ariza rad etiladi',
  'requirements.noneStated':
    "Lot hujjatlarini tahlil qildik — malaka talablari ularda ko'rsatilmagan.",
  'requirements.noDocuments':
    "{{name}} maydonchasi hujjatlarni bu yerda e'lon qilmaydi — manbada ko'ring.",
  'requirements.noDocumentsGeneric':
    "Bu lotning hujjatlari faqat manba maydonchasida e'lon qilinadi.",
  'requirements.noDocumentsLocked':
    'Bu lot hujjatlari faqat manba maydonchasida joylashgan. Lotni maydonchada ochish — Pro tarifida.',
  'requirements.openOnSource': 'Lotni maydonchada ochish',
  'requirements.unreadable':
    "Hujjat skan sifatida yoki biz hali o'qiy olmaydigan formatda biriktirilgan.",
  'requirements.openDocument': 'Hujjatni ochish',
  'requirements.pending': 'Hujjatlarni tahlil qilyapmiz, odatda 2 soatgacha.',
  'requirements.locked': 'Talablar tahlili Pro tarifida',
  'requirements.lockedCta': "Tariflarni ko'rish",
  'plans.checkout': 'Rasmiylashtirish',
  'plans.checkoutGuest': 'Rasmiylashtirish uchun kiring',
  'plans.redirecting': "Yo'naltirilmoqda…",
  'plans.tinRequired': "Bu tarif uchun kompaniya STIRi kerak. Uni kiriting va to'lovga qayting.",
  'plans.checkoutError': "Rasmiylashtirib bo'lmadi. Qayta urinib ko'ring.",
  'plans.loadError': "Tariflarni yuklab bo'lmadi.",
  'plans.loadRetry': 'Qayta urinish',
  'plans.payWithPayme': "To'lash · Payme",
  'plans.payOnce': "Bir martalik to'lov",
  'plans.payOnceWithPrice': "Bir martalik to'lov — {{amount}}",
  'plans.payOnceNote': 'Avtomatik uzaytirishsiz · obunadan 10% qimmatroq',
  'plans.payOnceNoRenew': "Bir martalik to'lov, avtomatik uzaytirishsiz",
  'plans.onceAmount': "To'lovga: {{amount}} — 1 oy uchun",
  'plans.payWithClick': "Click orqali to'lash",
  'plans.payOnceViaPayme': "Payme orqali to'lash",
  'plans.payOnceOrLabel': "Yoki bir marta to'lash — {{amount}}",
  'plans.payMethodLabel': "To'lov usuli",
  'plans.clickCards': 'Uzcard · Humo · Visa',
  'plans.paymentVia': "To'lov operatorlari:",
  'plans.payByAccount': "Hisob-raqami orqali to'lash",
  'plans.invoiceSub': 'Ommaviy oferta + buxgalteriya uchun hisob-faktura',
  'plans.orPayByCard': "Yoki ilova orqali karta bilan to'lash",
  'plans.yearAccessNote': 'Avtomatik uzaytirishsiz — 12 oyga kirish',
  'plans.payWithCard': "Karta bilan to'lash (Uzcard/Humo)",
  'plans.payByInvoice': "Hisob orqali to'lov (yuridik shaxslar uchun)",
  'plans.paymeOnlyNote': "Oylik to'lov — faqat onlayn, Payme orqali.",
  'plans.bankTransferTitle': "To'lov uchun rekvizitlar",
  'plans.bankAmount': "To'lov summasi",
  'plans.downloadInvoice': 'Hisobni yuklab olish',
  'plans.bankNote': "Pro tarifi to'lov hisob raqamiga tushgach faollashtiriladi.",

  // ── Hisob orqali to'lov: uch bosqichli oyna (2026-09-15) ─────────────────
  // «Счёт на оплату» — rus tilidagi buxgalteriya hujjati, PDF faqat rus tilida
  // chiqadi (formaning o'zbekcha varianti yo'q). Interfeys esa to'liq
  // tarjima qilingan.
  'invoiceFlow.tinLabel': 'Tashkilotingiz STIRi',
  'invoiceFlow.tinLooking': 'Reyestrdan qidiryapmiz…',
  'invoiceFlow.nameLabel': 'Tashkilot nomi',
  'invoiceFlow.namePlaceholder': '«Namuna» MChJ',
  'invoiceFlow.tinIncomplete': 'STIR 9 ta raqamdan iborat',
  'invoiceFlow.nameRequired': 'Nomini yozing — u hisobda chop etiladi',
  'invoiceFlow.accessPeriod':
    "Faollashtirilgan kundan boshlab 12 oy kirish — bugun to'lasangiz {{date}}-gacha.",
  'invoiceFlow.issue': 'Hisob chiqarish',
  'invoiceFlow.issuing': 'Chiqaryapmiz…',
  'invoiceFlow.errIssue':
    "Hisobni chiqara olmadik. STIR to'g'riligini tekshirib, qayta urinib ko'ring.",
  'invoiceFlow.readyTitle': '№ {{number}} hisob',
  'invoiceFlow.purposeLabel': "To'lov maqsadi (majburiy)",
  'invoiceFlow.purposeWarning':
    "Har bir hisobning o'z to'lov maqsadi bor. Boshqa hisobning maqsadi pul o'tishini kechiktiradi. Uchinchi shaxs nomidan to'lov qabul qilinmaydi.",
  'invoiceFlow.copy': 'Nusxalash',
  'invoiceFlow.copied': 'Nusxalandi',
  'invoiceFlow.download': 'PDF yuklab olish',
  'invoiceFlow.sendEmail': 'Pochtaga yuborish',
  'invoiceFlow.emailSent': 'Pochtaga yuborildi',
  'invoiceFlow.sendTelegram': 'Telegramga yuborish',
  'invoiceFlow.telegramSent': 'Telegramga yuborildi',
  'invoiceFlow.errSend': "Yuborib bo'lmadi. PDF'ni yuklab oling yoki keyinroq urinib ko'ring.",
  'invoiceFlow.errDownload': "PDF'ni yuklab bo'lmadi — hisobni pochtaga yoki Telegramga yuboring.",
  'invoiceFlow.errNoEmail':
    "Hisobda pochta manzili yo'q — PDF'ni yuklab oling yoki Telegramga yuboring.",
  'invoiceFlow.errNoTelegram': 'Telegram ulanmagan — bildirishnoma sozlamalarida ulang.',
  'invoiceFlow.connectTelegram':
    'Hisob-faktura va bildirishnomalarni olish uchun profilda Telegramni ulang',
  'invoiceFlow.activationNote': 'Pul tushgandan keyin 3 ish kuni ichida kirish ochiladi.',
  'invoiceFlow.needFaster': 'Tezroq kerakmi?',
  'invoiceFlow.savedNote':
    'Hisob shaxsiy kabinetingizda saqlandi — uni qayta yuklab olish va yuborish mumkin.',
  'plans.freeStart': 'Bepul boshlash',
  'plans.currentPlan': 'Joriy tarif',
  'plans.otherMethods': "Boshqa to'lov usullari",
  'plans.toggleMonthly': 'Oy',
  'plans.toggleYearly': 'Yil',
  'plans.periodToggleLabel': "To'lov davri",
  'plans.badgePopular': 'Ommabop',
  'plans.badgeBestValue': 'Foydali',
  'plans.savings': "Oylik to'lovga nisbatan ~{{percent}}% tejaysiz",
  'plans.badgeX2': '×{{multiple}} foyda',
  'plans.savingsX2': 'Bir yil — olti oy narxiga, {{som}} {{currency}} tejaysiz',
  'plans.refYearAria': "Oylik to'lovda bir yil {{som}} {{currency}} bo'lardi",
  'plans.consentPrefix': "To'lov qilish orqali siz",
  'plans.consentOffer': 'ommaviy oferta',
  'plans.consentAnd': 'va',
  'plans.consentPrivacy': 'maxfiylik siyosati',
  'plans.consentSuffix': ' bilan rozilik bildirasiz.',
  // ── Footer ─────────────────────────────────────────────────────
  'footer.plans': 'Tariflar',
  // ── Directory (/directory) ───────────────────────────────────────────────
  'directory.title': 'Barcha toifalar va hududlar',
  'directory.intro':
    "Katalog bo'limlarining to'liq ko'rsatkichi: {{countryGen}} tenderlari va davlat xaridlari xarid yo'nalishi va buyurtmachi hududi bo'yicha. Har bir bo'lim yonida undagi faol tenderlar soni ko'rsatilgan.",
  'directory.seoTitle': '{{countryGen}} tenderlari: toifalar va hududlar',
  'directory.seoDesc':
    "{{country}} davlat xaridlari katalogining barcha bo'limlari: 31 ta xarid yo'nalishi va 14 ta hudud bo'yicha tenderlar, har birida faol tenderlar soni bilan.",
  'directory.categories.h2': "Xarid yo'nalishi bo'yicha",
  'directory.categories.intro':
    "Yo'nalish lotning tovar guruhi bilan belgilanadi — qurilish mollaridan IT va tibbiyotgacha.",
  'directory.regions.h2': "Buyurtmachi hududi bo'yicha",
  'directory.regions.intro': 'Hudud — buyurtmachining joylashuvi, yetkazib berish joyi emas.',
  'directory.companies.h2': 'Davlat xaridlarida ishtirok etuvchi kompaniyalar',
  'directory.companies.intro':
    "{{country}} davlat xaridlarida tarixi bo'lgan yetkazib beruvchilar va buyurtmachilar katalogi: reyestrdagi holati, ishonchliligi va shartnomalar hajmi.",
  'goodStanding.tier.debarred': 'Insofsizlar reyestrida',
  'goodStanding.tier.liquidated': 'Tugatilgan',
  'goodStanding.tier.flagged': 'KGD reyestrida (soliq xavflari)',
  'goodStanding.tier.active_supplier': 'Faoliyatdagi yetkazib beruvchi',
  'goodStanding.tierBuyer.active_supplier': 'Faoliyatdagi buyurtmachi',
  'goodStanding.tier.active': 'Faoliyatdagi kompaniya',
  'companies.title': '{{country}} davlat xaridlaridagi kompaniyalar',
  'companies.intro':
    "Davlat xaridlarida ishtirok etish tarixi bo'lgan yetkazib beruvchilar va buyurtmachilar. Har bir kompaniya yonida — reyestrdagi holati va shartnomalar hajmi.",
  'companies.seoTitle': '{{country}} davlat xaridlari ishtirokchi kompaniyalari katalogi',
  'companies.seoTitlePaged': 'Davlat xaridlari kompaniyalari katalogi — {{page}}-sahifa',
  'companies.seoDescPaged':
    '{{country}} davlat xaridlari ishtirokchi kompaniyalari — {{page}}-sahifa, jami {{totalPages}} sahifadan, jami {{count}}. Buyurtmachilar va yetkazib beruvchilar, shartnomalar — {{brand}}.',
  'companies.seoDesc':
    "{{country}} davlat xaridlari yetkazib beruvchilari va buyurtmachilari: har bir kompaniya bo'yicha reyestr holati, ishonchliligi va shartnomalar tarixi.",
  'companies.search': 'Nomi yoki STIR',
  'companies.filter.allSectors': 'Barcha sohalar',
  'companies.filter.allRegions': 'Barcha hududlar',
  'companies.filter.allRoles': 'Barcha kompaniyalar',
  'companies.role.supplier': 'Yetkazib beruvchilar',
  'companies.role.buyer': 'Buyurtmachilar',
  'companies.role.both': 'Ham yetkazib beruvchi, ham buyurtmachi',
  'companies.rowRole.supplier': 'Yetkazib beruvchi',
  'companies.rowRole.buyer': 'Buyurtmachi',
  'companies.rowRole.both': 'Buyurtmachi va yetkazib beruvchi',
  'companies.contractsAs.supplier': 'Yetkazib beruvchi sifatida: {{count}} ta shartnoma',
  'companies.contractsAs.buyer': 'Buyurtmachi sifatida: {{count}} ta shartnoma',
  'companies.contracts': '{{count}} ta shartnoma',
  'companies.empty': "Kompaniyalar topilmadi. Filtrlarni o'zgartiring.",
  'companies.loadMore': "Yana ko'rsatish",
  'companies.count': 'Topilgan kompaniyalar: {{count}}',
  'nav.companies': 'Kompaniyalar',
  'nav.guide': 'Qanday ishtirok etiladi',
  'footer.directory': 'Toifalar va hududlar',
  'footer.about': 'Xizmat haqida',
  'footer.guide': "Yetkazib beruvchilar uchun qo'llanma",
  'footer.offer': 'Ommaviy oferta',
  'footer.privacy': 'Maxfiylik',
  'footer.requisites': 'Rekvizitlar',
  'footer.support': 'Yordam',
  'nav.about': 'Xizmat haqida',
  'nav.subscription': 'Obuna',
  // ── About page (/about) ────────────────────────────────────────
  'about.pageTitle': '{{brand}} xizmati haqida',
  'about.subtitle': '{{countryGen}} davlat tenderlari va xaridlari agregatori.',
  'about.lead':
    "{{brand}} — {{country}} davlat xaridlarining yagona katalogi. Biz tenderlarni rasmiy platformalardan bir joyga to'playmiz, o'zbek va rus tilida xaridlar tahlilini qo'shamiz va yetkazib beruvchilarga mos davlat shartnomalarini tezroq topishga yordam beramiz.",
  'about.what.title': 'Biz nima qilamiz',
  'about.what.body':
    "Har necha soatda byudjetli davlat xaridlari katalogini yangilaymiz, har bir tenderning hududi, toifasi va predmetini aniqlaymiz va ularni qidiruv uchun qulay qilamiz — sizga o'nlab platformalarni qo'lda kuzatish shart emas.",
  'about.feature.catalog.title': 'Yagona katalog',
  'about.feature.catalog.desc':
    "Hudud, toifa, byudjet va muddat bo'yicha filtrlar bilan minglab dolzarb tenderlar.",
  'about.feature.ai.title': 'Xaridlar tahlili',
  'about.feature.ai.desc':
    "Har bir tenderning o'zbek va rus tilidagi qisqa tavsifi — xarid mohiyati darhol tushunarli.",
  'about.feature.search.title': 'Aqlli qidiruv',
  'about.feature.search.desc':
    "Semantik qidiruv nafaqat aniq so'zlarni, balki so'rov ma'nosini ham tushunadi.",
  'about.feature.alerts.title': 'Telegram bildirishnomalari',
  'about.feature.alerts.desc':
    "Qidiruvni saqlang va yangi mos tenderlar haqida birinchi bo'lib biling.",
  'about.audience.title': 'Kimlar uchun',
  'about.audience.body':
    "{{country}} davlat xaridlarida qatnashadigan va tegishli tenderlarni birinchi bo'lib ko'rishni istagan yetkazib beruvchilar, pudratchilar va ishlab chiqaruvchilar uchun.",
  'about.sources.title': "Ma'lumot manbalari",
  'about.sources.body':
    "Biz {{country}} davlat xaridlarining rasmiy platformalaridan (xarid.uzex.uz, etender.uzex.uz, xt-xarid.uz va boshqalar) ommaviy ma'lumotlarni to'playmiz. {{brand}} — mustaqil xizmat bo'lib, davlat portali emas.",
  'about.press.title': 'Biz haqimizda yozishadi',
  'about.contact.title': "Biz bilan bog'lanish",
  'about.contact.body': "Hamkorlik, obuna va yordam bo'yicha bizga yozing:",
  'about.operator': 'Xizmat operatori — {{legalName}}.',
  'about.operator.requisitesLink': 'Rekvizitlar',
  'footer.rights': 'Barcha huquqlar himoyalangan.',
  'footer.inn': 'STIR',
  'footer.phone': 'Telefon',
  // ── Legal pages (oferta / siyosat) ─────────────────────────────
  'legal.updated': 'Oxirgi yangilanish',
  'legal.requisitesHeading': 'Ijrochi rekvizitlari',
  // ── Requisites page ────────────────────────────────────────────
  'requisites.pageTitle': 'Rekvizitlar',
  'requisites.subtitle': 'Servis operatorining yuridik va bank rekvizitlari.',
  'requisites.note':
    "Ushbu rekvizitlar yillik obunani hisob orqali to'lash uchun ishlatiladi (yuridik shaxslar va YaTT uchun).",
  // ── Invoice (to'lov uchun hisob) ────────────────────────────────────
  'invoice.pageTitle': "To'lov uchun hisob",
  'invoice.title': "To'lov uchun hisob",
  'invoice.date': 'Sana',
  'invoice.back': '← Tariflarga',
  'invoice.print': 'Chop etish / PDF',
  'invoice.seller': 'Yetkazib beruvchi (Ijrochi)',
  'invoice.buyer': "To'lovchi (Buyurtmachi)",
  'invoice.buyerName': 'Nomi',
  'invoice.buyerInn': 'STIR',
  'invoice.itemName': 'Xizmat nomi',
  'invoice.itemQty': 'Soni',
  'invoice.itemPrice': 'Summa',
  'invoice.itemPlan': '{{name}} obunasi (yillik), {{brandHost}} xizmatiga kirish',
  'invoice.total': "Jami to'lovga",
  'invoice.note':
    "Ko'rsatilgan summani yetkazib beruvchining hisob raqamiga o'tkazing. {{name}} tarifi mablag' tushgach faollashtiriladi. To'lov maqsadi: {{name}} obunasi uchun to'lov, {{brandHost}}.",
  // ── Tender detail extras ───────────────────────────────────────
  'tender.budgetLabel': 'Byudjet',
  'tender.deadlineLabel': 'Muddat',
  'tender.daysLeftText': '{{days}} qoldi',
  'tender.nav.description': 'Tavsif',
  'tender.nav.procedure': 'Tartib',
  'tender.nav.documents': 'Hujjatlar',
  'tender.nav.lotDetails': 'Yetkazib berish',
  'tender.identity.platform': 'Platforma',
  'tender.lotDetails.title': 'Yetkazib berish shartlari',
  'tender.lotDetails.unitPrice': 'Birlik narxi',
  'tender.lotDetails.qty': 'Miqdori',
  'tender.lotDetails.unit': "O'lchov birligi",
  'tender.lotDetails.deliveryPlace': 'Yetkazish joyi',
  'tender.lotDetails.deliveryTerm': 'Yetkazish muddati',
  'tender.lotDetails.advancePct': 'Avans',
  'tender.lotDetails.paymentType': "To'lov shartlari",
  'tender.lotDetails.paymentTermDays': "To'lov muddati",
  'tender.lotDetails.positions': 'Lot pozitsiyalari: {{n}}',
  'tender.lotDetails.incoterms': 'Inkoterms',
  'tender.lotDetails.purchaseType': 'Xarid turi',
  'tender.lotDetails.batchLotCount': "E'londagi lotlar",
  'tender.lotDetails.batchTotal': 'Xarid summasi',
  'tender.lotDetails.legalAddress': 'Buyurtmachining yuridik manzili',
  'tender.nav.requirements': 'Talablar',
  'tender.nav.contacts': 'Kontaktlar',
  'tender.nav.integrity': 'Parametrlar',
  'tenderIntegrity.title': 'Protsedura parametrlari',
  'tenderIntegrity.hint':
    "E'tibor berish kerak bo'lgan belgilar: qayta e'lon qilish, yagona ishtirokchi, garov, talablar. Faqat faktlar, bahosiz.",
  'tenderIntegrity.teaserRelisting': "Lotni qayta e'lon qilish",
  'tenderIntegrity.teaserDeposit': 'Garov / byudjet nisbati',
  'tenderIntegrity.teaserBasis': "Lot hujjatlari bo'yicha tekshiruvlar: {{n}} ta",
  'tenderIntegrity.relisting': "#{{id}} protseduradan qayta e'lon qilingan",
  'tenderIntegrity.prevFailed': 'oldingisi amalga oshmagan',
  'tenderIntegrity.prevParticipants': 'undagi ishtirokchilar: {{n}}',
  'tenderIntegrity.participants': "Ro'yxatdan o'tgan ishtirokchilar: {{n}}",
  'tenderIntegrity.single': "Yagona ro'yxatdan o'tgan ishtirokchi",
  'tenderIntegrity.deposit': 'Garov byudjetning {{pct}}%',
  'tenderIntegrity.median': "bo'lim bo'yicha mediana — {{pct}}%",
  'tenderIntegrity.quals': 'Diskvalifikatsiya qiluvchi talablar: {{n}}',
  'tenderIntegrity.qualsShow': "Talablarni ko'rsatish",
  'tenderIntegrity.weights': 'baholash {{tech}}:{{cost}} (texnika:narx)',
  'tenderIntegrity.source': "Protsedura bayonnomalari va xaridlar grafi bo'yicha",
  'tender.callAction': "Qo'ng'iroq qilish",
  'tender.summaryLabel': 'Tavsif',
  'tender.detailLabel': 'Tavsif',
  'tender.overview.description': 'Tavsif',
  'tender.overview.specification': 'Spetsifikatsiya',
  'tender.overview.bidSecurity': "Ariza ta'minoti",
  'tender.documentTextLabel': 'Hujjat matni',
  'tender.noSummary': 'Bu tender uchun xulosa hali mavjud emas.',
  // ── Tender gate card (two-wall model: free = hard Pro wall, 0 opens) ───
  'tender.reveal.title': 'Buyurtmachi kontaktlari',
  'tender.reveal.remaining': 'Bu oyda qolgan ochishlar: {{count}}',
  'tender.reveal.action': "Kontaktlarni ko'rsatish",
  // Buyurtmachi kontakt qoldirmagan lot: ochish faqat asl e'longa havola beradi
  // — buni ochish hisobdan yechilishidan OLDIN aytamiz.
  'tender.reveal.titleNoContact': "Asl e'lon",
  'tender.reveal.noContactHint':
    "Buyurtmachi bu tender uchun kontakt e'lon qilmagan. Ochish savdo maydonchasidagi asl e'longa havola beradi.",
  'tender.reveal.actionNoContact': 'Asl tenderni ochish',
  'tender.reveal.pending': 'Ochilmoqda…',
  'tender.reveal.ceiling':
    'Bu tender byudjeti tarifingiz limitidan yuqori. Bunday tenderlar kontaktlari Pro tarifida mavjud.',
  'tender.reveal.exhausted':
    "Bu oyga kontakt ochishlar tugadi. Limit har oyning 1-sanasida yangilanadi — yoki limitsiz Pro tarifiga o'ting.",
  'tender.reveal.error': "Kontaktlarni ochib bo'lmadi. Qaytadan urinib ko'ring.",
  // ── Per-account read ceiling ────────────────────────────────────────────
  // Bu devor ham, Pro reklamasi ham EMAS: bu holatga faqat kontaktlarga haqli
  // foydalanuvchi tushadi. {{limit}} serverdan keladi, {{time}} — sutkalik
  // oyna qayta ochiladigan payt (UTC, ya'ni Toshkent vaqti bilan 05:00),
  // shuning uchun «ertaga» emas, aniq VAQT aytiladi.
  'tender.reveal.limitedDay':
    "Bugun kontakt ochish limiti tugadi ({{limit}}). Limit Toshkent vaqti bilan {{time}} da yangilanadi. Agar bu xato bo'lsa — qo'llab-quvvatlash xizmatiga yozing.",
  'tender.reveal.limitedMinute':
    "Siz ketma-ket juda ko'p kontakt ochdingiz. Bir daqiqa kuting va qaytadan urinib ko'ring. Agar bu xato bo'lsa — qo'llab-quvvatlash xizmatiga yozing.",
  'tender.reveal.limitedSupport': "Qo'llab-quvvatlash xizmatiga yozish",

  // «Ariza paketi» — BID_PACKAGE_ENABLED bayrog'i ortida, faqat Pro uchun.
  'tender.bidPackage.title': 'Ariza paketi',
  'tender.bidPackage.cta': "Ariza yig'ish",
  'tender.bidPackage.statusIdle': "Yig'ilmagan",
  'tender.bidPackage.statusReady': 'Tayyor',
  'tender.bidPackage.statusReadyOn': "Tayyor · yig'ilgan sana: {{date}}",
  'tender.bidPackage.statsDocs': 'majburiy hujjatlar {{n}}',
  'tender.bidPackage.statsGaps': "bo'sh joylar {{n}}",
  'tender.bidPackage.statsProfile': "anketa {{pct}} % to'ldirilgan",
  'tender.bidPackage.profileFill': "Kompaniya anketasini to'ldirish →",
  'tender.bidPackage.details': 'Batafsil ochish',
  'tender.bidPackage.detailsHide': 'Batafsilni yopish',
  'tender.bidPackage.gateWarn': "Paket bo'sh joylar bilan chiqadi: anketa {{pct}} % to'ldirilgan.",
  'tender.bidPackage.gateLink': "To'ldirish →",
  'tender.bidPackage.building': 'Yaratilmoqda…',
  'tender.bidPackage.preparing': 'Hujjatni tayyorlayapmiz, Telegram va pochtaga yuboramiz',
  'tender.bidPackage.preparingHint':
    "Sahifani yopsangiz ham bo'ladi — odatda 10–30 soniya oladi. Tayyor paket shu yerda ham qoladi.",
  'tender.bidPackage.failed': "Paketni yig'ib bo'lmadi.",
  'tender.bidPackage.retry': 'Qaytarish',
  'tender.bidPackage.error': "Paketni yig'ib bo'lmadi. Qaytadan urinib ko'ring.",
  'tender.bidPackage.errorNotGranted': 'Ariza paketi hozircha hisobingiz uchun ochiq emas.',
  'tender.bidPackage.errorMonthlyLimit':
    "Bu oylik limit tugadi — oyiga 3 ta yig'ish. Allaqachon yig'ilgan paketlar cheklovsiz ochiladi, limit har oyning 1-sanasida yangilanadi.",
  'tender.bidPackage.errorGrantLimit':
    "Ruxsatingiz bo'yicha yig'ishlar tugadi. Allaqachon yig'ilgan paketlar cheklovsiz ochiladi — ko'proq kerak bo'lsa, bizga yozing.",
  'tender.bidPackage.errorRegenCooldown':
    "Bu paketni soatiga bir marta qayta yig'ish mumkin. Joriy versiya ochiq qolaveradi.",
  'tender.bidPackage.downloadError': "Faylni yuklab bo'lmadi. Qaytadan urinib ko'ring.",
  'tender.bidPackage.stale': "Paket yig'ilgandan keyin e'lon o'zgargan.",
  'tender.bidPackage.rebuild': "Qaytadan yig'ish",
  'tender.bidPackage.regenerate': "Qayta yig'ish",
  // Dedlayn-geyt: yig'ishga endi hech narsa yo'q, yig'ilgani esa yuklab olinadi.
  'tender.bidPackage.ctaClosed': 'Arizalar qabuli yopiq',
  'tender.bidPackage.errorTenderClosed':
    "Bu lot bo'yicha arizalar qabuli yopiq — paketni yig'ish endi mumkin emas.",
  // Qayta yig'ish amalga oshmadi, ammo avvalgi hujjat joyida va o'qiladi.
  'tender.bidPackage.rebuildFailed': "Qayta yig'ish amalga oshmadi, avvalgi hujjat ko'rsatilgan",
  // Status shartnomasidagi warnings kodlari. Notanish kod umuman chizilmaydi.
  'tender.bidPackage.warnClosingSoon': 'Qabul tugashiga bir kundan kam qoldi.',
  'tender.bidPackage.warnUzMachineTranslated':
    "O'zbekcha versiya avtomatik tarjima qilingan — topshirishdan oldin tekshiring.",
  'tender.bidPackage.checkedAgainst': "{{company}} ma'lumotlari bo'yicha tekshirildi",
  'tender.bidPackage.noCompany':
    "Profilda STIR ko'rsatilmagan, shuning uchun talablarni kompaniyangiz bo'yicha tekshira olmadik — barcha bandlarni o'zingiz tekshiring.",
  'tender.bidPackage.admissionOk': 'Topshirish mumkin',
  'tender.bidPackage.admissionBlocked': "To'siqlar bor: {{count}}",
  'tender.bidPackage.admissionTitle': 'Ruxsat tekshiruvi',
  'tender.bidPackage.deadlineLabel': 'Qabul muddati',
  'tender.bidPackage.methodLabel': 'Topshirish usuli',
  'tender.bidPackage.methodUnknown':
    "maydoncha bir necha protsedura olib boradi — turini lot kartasidan ko'ring",
  'tender.bidPackage.submitTitle': 'Qayerga va qanday topshirish kerak',
  'tender.bidPackage.submitEntry': 'Maydonchaga kirish',
  'tender.bidPackage.profileTitle': 'Kompaniya anketasi — faqat yetishmayotgani',
  'tender.bidPackage.profileLead':
    "Bu maydonlarni hech bir reestr e'lon qilmaydi, paketdagi shakllarga esa ular kerak. Bir marta so'raymiz.",
  'tender.bidPackage.profileContinue': 'Davom etish',
  'tender.bidPackage.profileSaving': 'Saqlanmoqda…',
  'tender.bidPackage.profileSaveError': "Anketani saqlab bo'lmadi. Yana urinib ko'ring.",
  'tender.bidPackage.profileSkipHint':
    "Istalgan maydonni o'tkazib yuborish mumkin — hujjatda uning o'rnida ko'rinadigan bo'sh joy qoladi, uni o'zingiz to'ldirasiz.",
  'tender.bidPackage.profileLink': "Kompaniyaning qolgan ma'lumotlari — profilda",
  'tender.bidPackage.groupAuto': "Sizning ma'lumotlaringiz bo'yicha tekshirildi",
  'tender.bidPackage.groupAutoHint':
    "Reyestr va g'alabalar tarixi bo'yicha tasdiqlandi. Bu komissiya tekshiruvini almashtirmaydi.",
  'tender.bidPackage.groupManual': "O'zingiz tekshiring",
  'tender.bidPackage.groupManualHint':
    "Faqat siz tasdiqlay oladigan majburiy talablar: sertifikatlar, ma'lumotnomalar, notarial nusxalar.",
  'tender.bidPackage.groupSoft': 'Buyurtmachi istaklari',
  'tender.bidPackage.emptyGroup': "E'londa ko'rsatilmagan.",
  'tender.bidPackage.evidence': 'Tasdiqlanadi: {{value}}',
  'tender.bidPackage.verdict.ok': 'mos kelasiz',
  'tender.bidPackage.verdict.fail': "o'tmaysiz",
  'tender.bidPackage.basis.registration': "Reyestr bo'yicha: {{value}}",
  'tender.bidPackage.basis.region': 'Kompaniya hududi: {{value}}',
  'tender.bidPackage.basis.legal_form': 'Tashkiliy shakli: {{value}}',
  'tender.bidPackage.basis.vat': "QQS to'lovchisi: {{value}}",
  'tender.bidPackage.basis.experience': "Shu sohadagi g'alabalar: {{value}}",
  'tender.bidPackage.documents': 'Arizaga ilova qilinadigan hujjatlar',
  'tender.bidPackage.mandatory': 'majburiy',
  'tender.bidPackage.optional': 'ixtiyoriy',
  'tender.bidPackage.coverLetter': 'Ishtirok etish arizasi — loyiha',
  'tender.bidPackage.offer': 'Tijorat taklifi — loyiha',
  'tender.bidPackage.offerHint': "Narxlarni to'ldirmaymiz: ularni siz qo'yasiz.",
  // Uzbekcha qoralamalardagi sariq belgi: ruscha — asosiy, uz — alohida model
  // chaqiruvi bilan tarjima, va uni arizada ismi turgan odam tekshirishi kerak.
  'tender.bidPackage.uzMark': 'tekshiring',
  'tender.bidPackage.uzMarkHint':
    "Matn o'zbekchaga avtomatik tarjima qilingan — topshirishdan oldin solishtiring.",
  'tender.bidPackage.colItem': 'Nomi',
  'tender.bidPackage.colQty': 'Soni',
  'tender.bidPackage.colUnit': "O'lchov",
  'tender.bidPackage.colPrice': 'Birlik narxi',
  'tender.bidPackage.download': 'DOCX yuklab olish',
  'tender.bidPackage.downloading': 'Fayl tayyorlanmoqda…',
  'tender.bidPackage.sendEmail': 'Pochtaga',
  'tender.bidPackage.sendTelegram': 'Telegramga',
  'tender.bidPackage.sending': 'Yuborilmoqda…',
  'tender.bidPackage.sentEmail': 'Pochtaga yubordik.',
  'tender.bidPackage.sentTelegram': 'Telegramga yubordik.',
  'tender.bidPackage.sendHint':
    'Agar fayl yuklanmasa — Instagram yoki Telegramning ichki brauzeri shunday qiladi — uni pochtadan yoki botdan oling.',
  'tender.bidPackage.sendError': "Yuborib bo'lmadi. Yana urinib ko'ring.",
  'tender.bidPackage.sendNoEmail': "Hisobda pochta manzili yo'q — uni profilda qo'shing.",
  'tender.bidPackage.sendNoTelegram': "Telegram ulanmagan — profilda botni bog'lang.",
  'tender.bidPackage.disclaimer':
    "E'lon va ilova qilingan fayllar matni asosida avtomatik tayyorlangan loyiha. Topshirishdan oldin asl e'lon bilan solishtiring — ariza mazmuni uchun javobgarlik ishtirokchida.",

  // ── «Tender hujjatlarini tayyorlash» — grantsiz hamma uchun lotdagi navbat tugmasi
  // (components/bid-waitlist-button.tsx).
  'tender.bidWaitlist.cta': 'Tender hujjatlarini tayyorlash (beta)',
  'tender.bidWaitlist.caption': "Ushbu lot bo'yicha ariza topshirish uchun hujjatlar to'plami",
  'tender.bidWaitlist.queued': 'Siz navbatdasiz',
  'tender.bidWaitlist.queuedCaption': 'Kirishni ochamiz va Telegram orqali yozamiz',
  'tender.bidWaitlist.error': "Navbatga yozilib bo'lmadi. Qayta urinib ko'ring.",
  // Anketa paydo bo'lishidan OLDIN tugmani bosgan o'quvchi uchun: bosish saqlanadi,
  // anketa qayta taklif qilinadi (egasi, 2026-09-29).
  'tender.bidWaitlist.captionReprompt': "Anketani to'ldiring",
  // Telegram ulanmagan hisob uchun navbat izohi.
  'tender.bidWaitlist.queuedCaptionEmail': 'Kirishni ochamiz va pochtaga yozamiz',

  // ── Shu tugma ortidagi anketa (components/bid-waitlist-form-modal.tsx, egasining
  // 2026-09-29 qarorlari). Shartlar bloki savollardan YUQORIDA — hech kim ularni
  // ko'rmasdan «Shartlar tushunarli» belgisini qo'ymasin. Atamalar ЗРУ-684
  // lug'atidan: заявка = ariza, договор = shartnoma, победа = g'alaba.
  'tender.bidWaitlistForm.title': 'Ariza uchun hujjatlar',
  'tender.bidWaitlistForm.beta': 'beta',
  'tender.bidWaitlistForm.intro':
    "Lot hujjatlari asosida ariza paketini yig'amiz: talablar, shakllar va hujjatlar loyihalari. Kirishni navbat bilan ochamiz.",
  'tender.bidWaitlistForm.termsTitle': 'Betadan keyingi shartlar',
  // «до 5 %» → «ko'pi bilan» (eng ko'pi) in the lead line, and the bare rate in
  // the cell: «0,5%-gacha» does not fit a third of a 360px phone and broke at
  // the hyphen (measured in headless Chromium, 29.09). Same meaning — a ceiling.
  'tender.bidWaitlistForm.termsLead':
    "Bizning hujjatlarimiz bilan g'olib bo'lsangiz — shartnoma va shartnoma summasidan xizmat haqi, ko'pi bilan:",
  'tender.bidWaitlistForm.tier1Range': "100 mln so'mgacha",
  'tender.bidWaitlistForm.tier1Fee': '5%',
  'tender.bidWaitlistForm.tier2Range': '10 mlrd-gacha',
  'tender.bidWaitlistForm.tier2Fee': '1%',
  'tender.bidWaitlistForm.tier3Range': '10 mlrd-dan ortiq',
  'tender.bidWaitlistForm.tier3Fee': '0,5%',
  'tender.bidWaitlistForm.termsUpload':
    'Ariza topshirilgach, uni bizga yuklaysiz — u asosida keyingisini yaxshilaymiz.',
  'tender.bidWaitlistForm.tinLabel': 'Kompaniya STIRi',
  'tender.bidWaitlistForm.tinPlaceholder': '{{tinDigits}} ta raqam',
  'tender.bidWaitlistForm.tinHint': "u orqali g'alabalaringizni ko'ramiz",
  'tender.bidWaitlistForm.tinMissing': 'Kompaniya STIRini kiriting — 9 ta raqam',
  'tender.bidWaitlistForm.supplyLabel': 'Nima yetkazib berasiz',
  'tender.bidWaitlistForm.supplyPlaceholder': "mebel, kanselyariya, tom ta'miri",
  'tender.bidWaitlistForm.bidsLabel': 'Oyiga nechta tenderga ariza topshirasiz',
  'tender.bidWaitlistForm.bids.0': '0',
  'tender.bidWaitlistForm.bids.1_3': '1–3',
  'tender.bidWaitlistForm.bids.4_10': '4–10',
  'tender.bidWaitlistForm.bids.10_plus': "10 dan ko'p",
  'tender.bidWaitlistForm.preparerLabel': 'Hozir hujjatlarni kim tayyorlaydi',
  'tender.bidWaitlistForm.preparer.self': "o'zimiz",
  'tender.bidWaitlistForm.preparer.employee': 'xodim',
  'tender.bidWaitlistForm.preparer.broker': 'broker',
  'tender.bidWaitlistForm.brokerPercentLabel': 'necha foizga',
  'tender.bidWaitlistForm.lotLabel': 'Odatdagi lot summasi',
  'tender.bidWaitlistForm.lot.to_100m': '100 mln-gacha',
  'tender.bidWaitlistForm.lot.to_1b': '1 mlrd-gacha',
  'tender.bidWaitlistForm.lot.to_10b': '10 mlrd-gacha',
  'tender.bidWaitlistForm.lot.over_10b': "10 mlrd-dan ko'p",
  'tender.bidWaitlistForm.agree': 'Shartlar tushunarli, bu menga qiziq',
  'tender.bidWaitlistForm.termsMissing':
    "Navbatga yozilish uchun «Shartlar tushunarli» belgisini qo'ying",
  'tender.bidWaitlistForm.submit': 'Navbatga yozilish',
  'tender.bidWaitlistForm.footnote':
    'Hozircha bu hech narsaga majburlamaydi. Kirishni ochayotganda javoblaringizni hisobga olamiz.',
  'tender.bidWaitlistForm.doneTelegram': 'Kirishni ochganimizda Telegram orqali yozamiz',
  'tender.bidWaitlistForm.doneEmail': 'Kirishni ochganimizda pochtaga yozamiz',
  'tender.bidWaitlistForm.doneOk': 'Tushunarli',

  // ── «Arizalar uchun kompaniya ma'lumotlari» — kabinetdagi doimiy anketa.
  'bidProfile.title': "Arizalar uchun kompaniya ma'lumotlari",
  'bidProfile.lead':
    "Imzolovchi, aloqa, rekvizitlar, litsenziyalar, tajriba va texnika — ularni har bir ariza paketi o'zi qo'yadi. Bir marta to'ldiring: aniq lot bo'yicha faqat bu yerda yetishmaganini so'raymiz.",
  'bidProfile.completeness': "{{total}} tadan {{filled}} tasi to'ldirilgan",
  'bidProfile.save': 'Saqlash',
  'bidProfile.saving': 'Saqlanmoqda…',
  'bidProfile.saved': 'Saqlandi.',
  'bidProfile.saveError': "Saqlab bo'lmadi. Yana urinib ko'ring.",
  'bidProfile.loadError': "Kompaniya ma'lumotlarini yuklab bo'lmadi.",
  'bidProfile.skipHint':
    "Istalgan maydonni bo'sh qoldirish mumkin — hujjatda uning o'rnida ko'rinadigan bo'sh joy qoladi, uni o'zingiz to'ldirasiz.",

  'tender.gate.title': 'Buyurtmachi hujjatlari va kontaktlari yashiringan',
  'tender.gate.lockedContacts': 'Buyurtmachi kontaktlari',
  'tender.gate.lockedWinnerContacts': "O'tgan tenderlar g'oliblarining kontaktlari",
  'tender.gate.lockedDocs': 'Tender hujjatlari',
  'tender.gate.lockedSummary': "TT to'liq tahlili",
  'tender.gate.lockedAnalytics': "Bozor va buyurtmachi bo'yicha analitika",
  'tender.gate.guest':
    "Bepul ro'yxatdan o'ting — saqlangan qidiruvlar va Telegram-bildirishnomalar",
  'tender.gate.free':
    "Pro'ni rasmiylashtiring — buyurtmachi kontaktlari, hujjatlar va bozor analitikasi",
  // Primary-action labels (sticky rail + mobile bottom bar)
  'tender.cta.register': "Ro'yxatdan o'tish",
  'tender.cta.pro': 'Pro tarifini faollashtirish',
  'tender.cta.contacts': 'Kontaktlarni ochish',
  // ── Free full-tender unlock (monthly free tier, or a campaign grant) ──
  'freeUnlock.title': 'Tenderni bepul ochish',
  // No count, no period — see the ru catalogue for why.
  'freeUnlock.buttonFree': "Pro-tarif ma'lumotlarini bepul ochish",
  'freeUnlock.remaining': 'Qolgan bepul ochishlar: {{n}}',
  'freeUnlock.pending': 'Ochilmoqda…',
  'freeUnlock.error': "Tenderni ochib bo'lmadi. Qaytadan urinib ko'ring.",
  'freeUnlock.spent': "Bepul ochish ishlatildi — Pro'ni rasmiylashtiring",
  'freeUnlock.needTin': "Kompaniya STIRini qo'shing",
  'freeUnlock.needPhone': "Telegram'da telefon raqamingizni tasdiqlang",
  'freeUnlock.phoneTaken': 'Bu raqam boshqa hisobda allaqachon ishlatilgan',
  'freeUnlock.completeProfile': "Profilni to'ldirish",
  'freeUnlock.confirmPhone': 'Telefonni tasdiqlash',
  'freeUnlock.orPro': "yoki Pro'ni rasmiylashtirish",
  // ── Dashboard ──────────────────────────────────────────────────
  'dashboard.greeting': 'Xush kelibsiz',
  // Add-category nudge (shown until the user saves their first search)
  'dashboard.nudge.title': "Toifa qo'shing — bildirishnoma oling",
  'dashboard.nudge.body':
    "Katalogdan toifa tanlab, uni saqlang. Yangi mos tender paydo bo'lishi bilanoq Telegram yoki email orqali xabar yuboramiz.",
  'dashboard.nudge.cta': "Toifa qo'shish",
  // Onboarding / activation checklist (dashboard)
  'onboarding.title': 'Sozlashni yakunlang',
  'onboarding.progress': '{{total}} tadan {{done}} ta',
  'onboarding.step.telegram': 'Telegram orqali kirish',
  'onboarding.step.telegramHint': 'Bildirishnoma olish uchun quyida Telegramni ulang.',
  'onboarding.step.search': 'Kamida bitta qidiruvni saqlang',
  'onboarding.step.inn': 'Kompaniya STIRini kiriting',
  'onboarding.step.innHint':
    "Kompaniyangiz nechta tenderda g'alaba qozonganini ko'rsatamiz. Shakl shu sahifada, quyida.",
  'onboarding.step.searchCta': "Qo'shish",
  // ИКПУ niche picker
  'ikpu.picker.placeholder': "Tovar nomi yoki kodi bo'yicha qidirish…",
  'ikpu.picker.searching': 'Qidirilmoqda…',
  'ikpu.picker.noResults': 'Hech narsa topilmadi',
  'ikpu.picker.remove': 'Olib tashlash',
  'ikpu.picker.activeCount': '{{count}} faol',
  'ikpu.picker.hint': "{{max}} tagacha yo'nalish tanlang",
  'ikpu.picker.max':
    "Maksimum tanlandi ({{max}}). Boshqasini qo'shish uchun bittasini olib tashlang.",
  'onboarding.niche.title': "Yo'nalish tanlang",
  'onboarding.niche.desc':
    "Ushbu yo'nalish bo'yicha har bir yangi mos tenderni Telegram'ga yuboramiz.",
  'onboarding.niche.save': 'Bildirishnomalarni yoqish',
  'onboarding.niche.saving': 'Saqlanmoqda…',
  'onboarding.niche.saveNetworkError':
    "Saqlanmadi — aloqani tekshiring. Qayta urinib ko'rdik, lekin ulanish uzildi.",
  'onboarding.niche.saveError': "Yo'nalishni saqlab bo'lmadi. Qayta urinib ko'ring.",
  'onboarding.done.intro': 'Tayyor! Bildirishnomalar yoqildi.',
  'onboarding.done.sent': "Birinchi tender Telegram'ga yuborildi",
  'onboarding.done.sentDesc': 'Bundan keyin har bir yangi mos tender avtomatik keladi.',
  'onboarding.done.empty': "Hozircha bu yo'nalishda faol tenderlar yo'q.",
  'onboarding.done.emptyAdjacent':
    "Paydo bo'lishi bilan yuboramiz. Faol lotli o'xshash yo'nalishlar:",
  'onboarding.done.close': 'Tayyor',
  // First-login onboarding pop-up
  'onboarding.modal.title': "{{brand}}'ga xush kelibsiz!",
  'onboarding.modal.intro':
    "Mos tenderlarni o'tkazib yubormaslik uchun bildirishnomalarni sozlang.",
  'onboarding.modal.tgTitle': 'Telegramni ulang',
  'onboarding.modal.tgDesc':
    "Yangi tenderlar haqida bildirishnomalarni to'g'ridan-to'g'ri Telegramda oling.",
  'onboarding.modal.searchTitle': "Toifa qo'shing",
  'onboarding.modal.searchDesc':
    'Toifa tanlab, qidiruvni saqlang — yangi mos tenderlar haqida xabar yuboramiz.',
  'onboarding.modal.searchCta': 'Toifa tanlash',
  'onboarding.modal.later': 'Keyinroq',
  'onboarding.modal.close': 'Yopish',
  'onboarding.categories.title': 'Toifani tanlang',
  'onboarding.categories.desc':
    "Tanlangan yo'nalish bo'yicha yangi tenderlar va Telegram-bildirishnomalar.",
  'onboarding.categories.searchToggle': 'Topilmadimi? Qidirish →',
  'onboarding.categories.search': 'Toifa qidirish…',
  'onboarding.categories.searchNoResults': 'Hech narsa topilmadi',
  'onboarding.categories.searching': 'Qidirilmoqda…',
  'onboarding.categories.popular': 'Ommabop',
  'onboarding.ikpu.label': "Yoki tovar kodi bo'yicha",
  'onboarding.ikpu.hint':
    "Yozishni boshlang — istalgan so'rov bo'yicha aniq yo'nalishlarni ko'rsatamiz",
  'onboarding.categories.section': 'Toifalar',
  'onboarding.ikpu.section': "Aniq yo'nalishlar",
  'onboarding.categories.more': 'Yana {{count}} ta toifa',
  // Never shown on Uzbekistan (the tiles-first screen runs on KZ only); kept for key parity.
  'onboarding.categories.showMore': 'Yana {{count}} ta',
  'onboarding.saved':
    "Saqlandi — yo'nalishingizdagi yangi tenderlar haqida bildirishnomalar yoqildi.",
  'onboarding.stepOf': '{{n}}-qadam / {{total}}',
  'onboarding.back': '← Orqaga',
  'onboarding.tg.cta': "Yangi tenderlardan birinchi bo'lib xabardor bo'ling",
  'onboarding.tg.connectedDone': 'Telegram ulandi — hammasi tayyor.',
  'onboarding.sample.bot': '{{brand}} bot',
  'onboarding.sample.title': "Yo'nalishingiz bo'yicha yangi tender",
  // Generic fallback title; per-category examples below keep the preview on-topic.
  'onboarding.sample.tender': '«Davlat muassasasi uchun tovarlar yetkazib berish»',
  'onboarding.sample.tender.construction': "«Maktab binosini kapital ta'mirlash»",
  'onboarding.sample.tender.automotive':
    '«Muassasa ehtiyojlari uchun avtomobillar yetkazib berish»',
  'onboarding.sample.tender.food': "«Bolalar bog'chasi uchun oziq-ovqat yetkazib berish»",
  'onboarding.sample.tender.consulting': '«Qurilish ustidan texnik nazorat xizmatlari»',
  'onboarding.sample.tender.events-culture': "«Tantanali tadbirni tashkil etish va o'tkazish»",
  'onboarding.sample.tender.electrical':
    "«Transformator podstansiyasini yetkazib berish va o'rnatish»",
  'onboarding.sample.tender.machinery': '«Nasos uskunalarini yetkazib berish»',
  'onboarding.sample.tender.water-environmental':
    "«Suv ta'minoti tarmoqlarini rekonstruksiya qilish»",
  'onboarding.sample.tender.energy-fuel': "«Dizel yoqilg'isi yetkazib berish»",
  'onboarding.sample.tender.transport-logistics': '«Yuk tashish xizmatlari»',
  'onboarding.sample.tender.financial-legal': '«Moliyaviy hisobot auditi xizmatlari»',
  'onboarding.sample.tender.agriculture': "«Mineral o'g'itlar yetkazib berish»",
  'onboarding.sample.tender.chemicals': "«Bo'yoq va lok materiallarini yetkazib berish»",
  'onboarding.sample.tender.office-supplies': '«Kanselyariya tovarlarini yetkazib berish»',
  'onboarding.sample.tender.printing-publishing': "«O'quv qo'llanmalarini chop etish xizmatlari»",
  'onboarding.sample.tender.cleaning-sanitation': "«Ma'muriy binolarni tozalash xizmatlari»",
  'onboarding.sample.meta': '💰 2 400 000 000 {{currency}} · ⏰ 12 kun qoldi',
  'onboarding.sample.budget': '💰 {{amount}} {{currency}}',
  'onboarding.sample.daysLeft': '⏰ {{n}} {{word}} qoldi',
  'alerts.unconfirmed': "Pochta tasdiqlanmagan — faqat bitta to'plam keladi.",
  'alerts.unconfirmed.cta': 'Pochtani tasdiqlash',
  'dashboard.alerts.searchesCount': 'Saqlangan qidiruvlar: {{count}}.',
  'emailConfirm.ok': "Pochta tasdiqlandi — to'plamlar shu manzilga keladi.",
  'emailConfirm.expired': "Havola muddati o'tgan. Pochtani kod bilan tasdiqlang.",
  'emailConfirm.invalid': 'Havola ishlamadi. Pochtani kod bilan tasdiqlang.',
  'emailConfirm.signIn':
    'Saytga kiring — pochtani katalog ustidagi «Pochtani tasdiqlash» qatorida tasdiqlash mumkin.',
  'emailConfirm.close': 'Yopish',
  'onboarding.categories.pickPrompt': 'Davom etish uchun toifa tanlang',
  'onboarding.cta.connect': '«{{category}}» tenderlarini Telegramda olish',
  'onboarding.cta.finish': 'Tayyor',
  // Same nudge on the catalog (points to the «Kategoriya» filter above)
  'catalog.nudge.compact': 'Toifa tanlang va saqlang — yangi tenderlar Telegramda.',
  'dashboard.alerts': 'Bildirishnomalar',
  'dashboard.alerts.empty': 'Bildirishnomalar sozlanmagan.',
  'dashboard.alerts.active': 'Faol: {{count}} — yangi mos tenderlar Telegram orqali keladi.',
  'dashboard.alerts.activeEmail': 'Faol: {{count}} — yangi mos tenderlar pochtaga keladi.',
  'dashboard.alerts.activeBoth':
    'Faol: {{count}} — yangi mos tenderlar Telegram va pochtaga keladi.',
  'dashboard.alerts.allChannelsOff':
    "Saqlangan qidiruvlar: {{count}}, lekin barcha bildirishnoma kanallari o'chirilgan — hech narsa kelmaydi.",
  'dashboard.alerts.connectTg': 'Bildirishnoma olish uchun yuqorida Telegramni ulang.',
  'dashboard.alerts.noSearches':
    "Yo'nalishingizdagi yangi tenderlar haqida bildirishnoma olish uchun qidiruvni saqlang.",
  'dashboard.notifications': 'Yangi tenderlar haqida bildirishnomalar',
  'dashboard.notifications.hint':
    "Mos tenderlar haqida Telegram yoki email orqali xabar. Barcha bildirishnomalarni to'xtatish uchun o'chiring.",
  'dashboard.notifications.email': 'Email-bildirishnomalar',
  'dashboard.notifications.email.hint': 'Mos tenderlar emailingizga keladi.',
  'dashboard.notifications.telegram': 'Telegram-bildirishnomalar',
  'dashboard.notifications.telegram.hint': 'Mos tenderlar Telegram orqali keladi.',
  'dashboard.notifications.telegram.connectFirst': 'Yuqorida Telegramni ulang',
  'dashboard.plan': 'Sizning tarifingiz',
  'dashboard.plan.free': "Bepul tarif — kontaktlar va eksportni ochish uchun o'ting.",
  'dashboard.plan.active': '{{plan}} tarifi faol — {{date}}-gacha amal qiladi.',
  'dashboard.plan.manage': 'Obunani boshqarish',
  'dashboard.plan.autoRenewOn': 'Avtomatik uzaytirish yoqilgan',
  'dashboard.plan.autoRenewOff': "Avtomatik uzaytirish o'chirilgan",
  'dashboard.matches.week': 'Saqlangan qidiruvlaringiz 7 kunda {{count}} ta yangi tender topdi.',
  'dashboard.matches.none':
    "So'nggi 7 kunda saqlangan qidiruvlaringiz bo'yicha yangi mosliklar yo'q.",
  // ── Support / contact-us ───────────────────────────────────────
  'support.trigger': "Yordam va qo'llab-quvvatlash",
  'support.title': "Yordam va qo'llab-quvvatlash",
  'support.desc': "Muammo yoki taklifni yozing — biz siz bilan email orqali bog'lanamiz.",
  'support.dashboard.desc': 'Savol yoki taklifingiz bormi? Bizga yozing — yordam beramiz.',
  'support.emailPrefix': 'Bizga pochta orqali yozing:',
  'support.telegramPrefix': 'Yoki bizga Telegram orqali yozing:',
  'support.phonePrefix': "Yoki qo'ng'iroq qiling:",
  'support.categoryLabel': 'Toifa',
  'support.category.improvement': 'Yaxshilash',
  'support.category.bug': 'Tizim xatosi',
  'support.category.subscription': 'Obuna',
  'support.category.notification': 'Bildirishnoma muammosi',
  'support.category.other': 'Boshqa',
  'support.messageLabel': 'Xabar',
  'support.messagePlaceholder': 'Nima yuz bergani yoki nimani yaxshilash mumkinligini yozing…',
  'support.emailLabel': 'Javob uchun email',
  'support.submit': 'Yuborish',
  'support.sending': 'Yuborilmoqda…',
  'support.success': "Rahmat! Biz siz bilan bog'lanamiz.",
  'support.done': 'Tayyor',
  'support.error': "Yuborib bo'lmadi. Qayta urinib ko'ring.",
  'support.invalid': "Toifani tanlang, xabar (kamida 5 belgi) va to'g'ri email kiriting.",
  'support.close': 'Yopish',
  // ── Billing return (post-payment landing) ──────────────────────
  'billing.return.pageTitle': "To'lov qabul qilindi",
  'billing.return.title': "To'lovingiz uchun rahmat!",
  'billing.return.body':
    "To'lov qabul qilindi va qayta ishlanmoqda. Tarifingiz bir necha daqiqa ichida avtomatik faollashtiriladi.",
  // Sessiya obunani ko'rsatgach `body`/`note` o'rniga chiqadi — kutish holatidagi
  // matn («qayta ishlanmoqda», «faollashmasa yozing») faol tarif yonida o'ziga
  // zid keladi.
  'billing.return.bodyActive': "To'lov muvaffaqiyatli — kirish allaqachon ochiq.",
  'billing.return.planActive': '{{plan}} tarifi faol',
  'billing.return.paidUntil': 'Kirish {{date}}-gacha ochiq',
  'billing.return.nextCharge': "Avtomatik uzaytirish yoqilgan · keyingi to'lov {{date}}",
  'billing.return.noteActive':
    "Obuna va to'lov tafsilotlari — shaxsiy kabinetda. Savollaringiz bo'lsa, {{brandEmail}}'ga yozing.",
  'billing.return.attachTitle': 'Avtomatik uzaytirishni yoqing',
  'billing.return.attachBody':
    "Kirish {{date}}-gacha. Kartani bog'lang — obuna qayta to'lovsiz o'zi uzayadi.",
  'billing.return.attachCta': "Kartani bog'lash",
  'billing.return.orderRef': 'Buyurtma raqami',
  'billing.return.ctaCatalog': "Tenderlarga o'tish",
  'billing.return.ctaTender': 'Tenderga qaytish',
  'billing.return.ctaDashboard': 'Shaxsiy kabinetga',
  'billing.return.note':
    "Agar tarif bir necha daqiqada faollashmasa, {{brandEmail}}'ga yozing — yordam beramiz.",
  // ── Billing return: to'lov RAD ETILDI ──────────────────────────
  // Shlyuz qaytish manzilida aytganda (`octo_status=canceled`, Click'ning
  // manfiy `payment_status`i) yoki buyurtma `cancelled` bo'lganda chiqadi.
  'billing.return.failedPageTitle': "To'lov amalga oshmadi",
  'billing.return.failedTitle': "To'lov amalga oshmadi",
  'billing.return.failedBody':
    "Bank to'lovni rad etdi yoki to'lov bekor qilindi — obuna faollashtirilmadi. Qayta urinib ko'rish mumkin: o'sha karta, boshqa karta yoki boshqa to'lov usuli bilan.",
  'billing.return.failedReasonFunds': "Kartada mablag' yetarli emas.",
  'billing.return.failedReasonCard': "Bank karta ma'lumotlarini qabul qilmadi.",
  'billing.return.failedReason3ds': "3-D Secure tasdig'i o'tmadi.",
  'billing.return.failedReasonExpired': 'Kartaning amal qilish muddati tugagan.',
  'billing.return.failedRetry': "Qayta urinib ko'rish",
  'billing.return.failedNote':
    "Agar pul baribir yechilgan bo'lsa — {{brandEmail}}'ga yozing, aniqlab beramiz.",
  // ── Team seats ─────────────────────────────────────────────────
  'team.pageTitle': 'Jamoa',
  'team.subtitle': "Bitta obuna bo'yicha xodimlar uchun Pro kirish.",
  'team.seats': "Band o'rinlar: {{limit}} tadan {{used}} ta",
  'team.role.owner': 'Egasi',
  'team.role.member': 'Xodim',
  'team.joined': "Jamoaga qo'shilgan",
  'team.rename': "Nomini o'zgartirish",
  'team.renameLabel': 'Jamoa nomi',
  'team.renameSave': 'Saqlash',
  'team.renameCancel': 'Bekor qilish',
  'team.invite': 'Taklif qilish',
  'team.inviteTitle': 'Taklif havolasi',
  'team.inviteHint':
    'Bu havolani xodimga yuboring — masalan, Telegram orqali. U bir martalik va 7 kun amal qiladi.',
  'team.inviteCopy': 'Nusxalash',
  'team.inviteCopied': 'Nusxalandi',
  'team.inviteClose': 'Yopish',
  'team.remove': "O'chirish",
  'team.removeConfirm': "Xodimni jamoadan o'chirasizmi? U Pro kirishni darhol yo'qotadi.",
  // Outstanding invitation links, listed under the roster for the owner only.
  'team.invitesTitle': 'Ishlatilmagan takliflar',
  'team.inviteExpires': '{{date}}-gacha amal qiladi',
  // Fallback when the expiry can't be formatted — the row still has to say
  // what it is, rather than render an empty line next to a revoke button.
  'team.inviteOutstanding': 'Havola faol',
  'team.revoke': 'Bekor qilish',
  'team.revokeConfirm':
    "Taklif bekor qilinsinmi? Havola darhol ishlamay qoladi — u orqali jamoaga qo'shilib bo'lmaydi.",
  'team.leave': 'Jamoadan chiqish',
  'team.leaveConfirm':
    "Jamoadan chiqasizmi? Jamoa obunasi orqali berilgan Pro kirishni darhol yo'qotasiz. Qaytish faqat yangi taklif havolasi orqali mumkin.",
  'team.disband': 'Jamoani tarqatish',
  'team.disbandConfirm':
    "Jamoa tarqatilsinmi? Jamoadagi xodimlar: {{count}} ta — ularning barchasi Pro kirishni darhol yo'qotadi, ishlatilmagan takliflar esa amal qilmay qoladi. Bu amalni ortga qaytarib bo'lmaydi.",
  'team.noSeats': "Barcha o'rinlar band. Yana taklif qilish uchun o'rin bo'shating.",
  // The owner can now SEE their unused links (the list above) and revoke one on
  // the spot, so this no longer hedges with "or wait for it to expire".
  'team.tooManyInvites':
    "Ishlatilmagan taklif havolalari juda ko'p. Yangisini yaratish uchun yuqoridagi ro'yxatdan birini bekor qiling.",
  'team.create': 'Jamoa yaratish',
  'team.emptyTitle': 'Jamoaviy kirish',
  'team.emptyBody': "«Biznes» tarifi 3 ta o'rin beradi: siz va ikki xodim.",
  'team.planRequired': 'Jamoaviy kirish «Biznes» tarifida mavjud.',
  'team.viaBadge': '«{{name}}» jamoasidan kirish',
  'team.error': "Jamoani yuklab bo'lmadi. Keyinroq urinib ko'ring.",
  'team.genericError': "Amalni bajarib bo'lmadi. Qayta urinib ko'ring.",
  // ── Team seats: /join/:token ──────────────────────────────────
  'join.title': 'Jamoaga taklif',
  'join.signedOut': "Taklifni qabul qilish uchun kiring yoki ro'yxatdan o'ting.",
  'join.accept': 'Taklifni qabul qilish',
  'join.accepting': 'Qabul qilinmoqda…',
  'join.success': 'Tayyor! Siz «{{name}}» jamoasidasiz.',
  'join.goToTeam': "Jamoaga o'tish",
  'join.ownSubscription':
    "Sizda {{date}}-gacha amal qiladigan o'z obunangiz bor. U asosiy bo'lib qoladi — jamoadagi o'rin u tugagach ishlay boshlaydi.",
  'join.ownSubscriptionNoDate':
    "Sizda o'z obunangiz bor. U asosiy bo'lib qoladi — jamoadagi o'rin u tugagach ishlay boshlaydi.",
  // Taklif tafsilotlari — tugmadan OLDIN (GET /teams/invitations/:token).
  'join.alreadyMember': 'Siz allaqachon «{{name}}» jamoasidasiz.',
  'join.invitedBy': 'Taklif qilgan: {{name}}',
  'join.teamPlan':
    'Jamoa tarifi: {{plan}} — buyurtmachilar kontaktlari, hujjatlar va tahlil ochiladi',
  'join.expiresAt': 'Havola {{date}}-gacha amal qiladi',
  'join.error.invite_not_found': 'Havola yaroqsiz.',
  'join.error.invite_expired': "Havola muddati tugagan. Yangisini so'rang.",
  'join.error.invite_used': 'Havola allaqachon ishlatilgan.',
  'join.error.invite_revoked': 'Taklif bekor qilingan.',
  'join.error.no_seats': "Jamoada bo'sh o'rin qolmagan.",
  // ONE string for both `already_in_team` and `is_team_owner` — see the note in
  // ru.ts: an owner holds their own seat, so they get `already_in_team` too and
  // cannot "leave"; both exits are named so the copy fits either case.
  'join.error.already_in_team':
    "Siz allaqachon jamoadasiz. Xodim «Jamoa» sahifasida jamoadan chiqishi mumkin, egasi esa o'sha yerda o'z jamoasini tarqatishi mumkin. Shundan so'ng taklifni qaytadan oching.",
  'join.error.generic': "Taklifni qabul qilib bo'lmadi. Keyinroq urinib ko'ring.",
  // Dead ends: an unmatched URL (404) and a route that failed to render.
  'notFound.title': 'Sahifa topilmadi',
  'notFound.body':
    "Manzilda xatolik bo'lishi yoki sahifa endi mavjud emasligi mumkin — masalan, tender e'londan olib tashlangan.",
  'notFound.action': 'Katalogga qaytish',
  'routeError.badge': 'Xatolik',
  'routeError.title': 'Sahifa ochilmadi',
  'routeError.body':
    "Yuklashda nimadir noto'g'ri ketdi. Sahifani yangilang yoki katalogga qayting.",
  'offline.banner': "Internet aloqasi yo'q",
  'offline.badge': "Tarmoq yo'q",
  'offline.title': "Internet aloqasi yo'q",
  'offline.body': 'Aloqani tekshiring va «Qayta urinish» tugmasini bosing.',
  'offline.lotBody':
    "Aloqa tiklanganda lot o'zi ochiladi. Yoki aloqani tekshirib, «Qayta urinish» tugmasini bosing.",
  'offline.listBody': "Internet aloqasi yo'q. Aloqa tiklanganda ro'yxat o'zi yuklanadi.",
  // ── Kind tabs (goods / works / services filter) ──────────────────
  'catalog.kind.all': 'Hammasi',
  'catalog.kind.goods': 'Tovarlar',
  'catalog.kind.works': 'Ishlar',
  'catalog.kind.services': 'Xizmatlar',
  'catalog.kind.aria': 'Xarid turi',
  // Accessible name for a tab once counts have loaded — the visible digits
  // are aria-hidden (see kind-tabs.tsx), so this is the only way a
  // screen-reader user hears the count before switching tabs.
  'catalog.kind.ariaLabel': '{{label}}, {{count}} ta tender',
  'company.title': 'Tashkilotingiz nomi yoki STIRi?',
  'company.subtitle':
    "Kompaniyangiz nimalarda g'alaba qozonganini — yoki sohangizda hozir nechta tender ochiqligini ko'rsatamiz.",
  'company.benefit.wins': "Kompaniyangiz nechta tenderda g'alaba qozonganini ko'rsatamiz",
  'company.benefit.alerts':
    "G'alabalar bo'lsa — avval yetkazib bergan mahsulotlaringiz bo'yicha bildirishnomalarni yoqamiz, filtrsiz",
  'company.benefit.plan':
    "Hududingiz va sohangizdagi tenderlarni o'tkazib yubormaslikka yordam beramiz",
  'company.card.change': "O'zgartirish",
  'company.card.activity': 'Faoliyat:',
  'company.card.status': 'Holat:',
  'company.card.region': 'Hudud:',
  'company.card.unknownName': 'Kompaniya aniqlanmadi',
  'company.card.notFound':
    "Bunday STIR reyestrda topilmadi. Raqamni tekshiring — yoki YaTT bo'lsangiz shundayligicha qoldiring: kompaniyalar reyestri ularni qaytarmaydi.",
  'company.savedTitle': 'STIR saqlandi',
  'company.done': 'Tayyor',
  'settings.title': 'Sozlamalar',
  'settings.section.company': 'Kompaniya',
  'settings.section.notifications': 'Bildirishnomalar',
  'settings.section.subscription': 'Obuna',
  'settings.section.account': 'Hisob',
  'settings.summary.company': 'Kompaniya',
  'settings.summary.noCompany': 'STIR kiritilmagan',
  'settings.summary.plan': 'Tarif',
  'settings.summary.planFree': 'Bepul',
  'settings.summary.planFreeHint': 'Buyurtmachi kontaktlari yopiq',
  'settings.summary.alerts': 'Bildirishnomalar',
  'settings.summary.alertsOn': 'Yoqilgan',
  'settings.summary.alertsOff': "O'chirilgan",
  'settings.summary.alertsOffHint': 'Telegram ulanmagan',
  'settings.account.email': 'Pochta',
  'settings.account.emailMissing': "ko'rsatilmagan",
  'settings.account.emailVerified': 'Tasdiqlangan',
  'settings.account.support': "Yordam va qo'llab-quvvatlash",
  // Telegram orqali kirgan akkauntda haqiqiy pochta yo'q — sintetik manzil
  // xat qabul qilmaydi. Shuning uchun bu qator pochtani QO'SHISHni taklif qiladi.
  'settings.account.attachEmail.hint':
    "Pochta ko'rsatilmagan — hisoblarni va kirish kodlarini yuborishning iloji yo'q",
  'settings.account.attachEmail.cta': "Pochtani ko'rsatish",
  'settings.account.attachEmail.label': 'Pochtangizni kiriting — tasdiqlash kodini yuboramiz',
  'settings.account.attachEmail.codeLabel': '{{email}} manziliga kod yuborildi. Uni kiriting:',
  'settings.account.attachEmail.send': 'Kod yuborish',
  'settings.account.attachEmail.confirm': 'Tasdiqlash',
  'settings.account.attachEmail.cancel': 'Bekor qilish',
  'settings.account.attachEmail.done': 'Pochta ulandi',
  'settings.account.attachEmail.error':
    "Kodni yuborib bo'lmadi. Manzilni tekshiring va qayta urinib ko'ring.",
  'settings.account.attachEmail.badCode': "Kod noto'g'ri yoki eskirgan. Yangisini so'rang.",
  'settings.account.attachEmail.alreadySet': 'Bu akkauntda haqiqiy pochta allaqachon bor.',
  'settings.account.attachEmail.mergeRefused':
    "Bu Telegram akkauntda obuna bor — qo'llab-quvvatlashga yozing, akkauntlarni qo'lda birlashtiramiz.",
  'company.tinLabel': 'STIR',
  'company.tinPlaceholder': '{{digits}} ta raqam',
  'company.lookup.label': 'Tashkilotingiz STIR yoki nomini kiriting',
  'company.lookup.placeholder': 'Nomi yoki {{digits}} raqamli STIR',
  'company.lookup.searching': 'Qidirilmoqda…',
  'company.lookup.empty': "Topilmadi — o'tkazib yuborib, keyinroq qo'shishingiz mumkin",
  'company.lookup.emptyNoSkip': "Nomi bo'yicha topilmadi — STIRni kiriting",
  'company.lookup.tinValue': 'STIR {{value}}',
  'company.lookup.wins.one': "2 yilda {{n}} ta g'alaba",
  'company.lookup.wins.few': "2 yilda {{n}} ta g'alaba",
  'company.lookup.wins.many': "2 yilda {{n}} ta g'alaba",
  'company.submit': 'Davom etish',
  'company.checking': 'Tekshirilmoqda…',
  'company.later': 'Keyinroq',
  'company.saved': 'STIR saqlandi.',
  'company.foundWins': "Kompaniyangiz g'alaba qozongan {{n}} ta {{word}} topildi",
  'company.foundSector': 'Sohangizda hozir {{n}} ta {{word}} ochiq',
  'company.foundRegion': 'Hududingizda hozir {{n}} ta {{word}} ochiq',
  'company.error.invalidTin': 'STIRni tekshiring: {{digits}} ta raqam kerak',
  'company.error.checksum': "Raqam tekshiruvdan o'tmadi — STIR raqamlarini tekshiring",
  'company.error.changeLimit': "Bugun STIR juda ko'p o'zgartirildi. Ertaga urinib ko'ring.",
  'company.error.generic': "Saqlab bo'lmadi. Qayta urinib ko'ring.",
  // «Моя компания»: claim-your-company-profile flow (dashboard card +
  // "Это моя компания?" CTA on public /supplier/:tin and /buyer/:tin pages).
  'claim.card.title': 'Yetkazib beruvchi profili',
  'claim.card.subtitle':
    "Kompaniya profilini hisobingizga bog'lang — mos tenderlar tanlovini olib turasiz.",
  'claim.card.cta': "Kompaniya profilini bog'lash",
  'claim.card.needsTin': "Avval yuqoridagi bo'limda kompaniya STIR raqamini kiriting.",
  'claim.preview.wins':
    "Bu kompaniya g'alaba qozongan {{n}} ta {{word}} topdik. Profilni bog'lab, mos yangi tenderlar haqida bildirishnoma olishni xohlaysizmi?",
  'claim.preview.none':
    "G'alabalar tarixi hali yo'q, lekin profilni bog'lab yangi tenderlar tanlovini olishingiz mumkin.",
  'claim.preview.confirm': "Ha, bog'lash",
  'claim.preview.cancel': 'Bekor qilish',
  'claim.linked.title': "Profil bog'landi",
  'claim.linked.wins': "G'alabalar tarixida {{n}} ta {{word}}",
  'claim.linked.note': 'Mos tenderlar haqida bildirishnomalar yoqildi.',
  'claim.conflict.title': "Bu STIR allaqachon boshqa hisobga bog'langan",
  'claim.conflict.body':
    "Agar bu sizning kompaniyangiz bo'lsa-yu, u hisobga kirish imkoniyati yo'qolgan bo'lsa, qo'llab-quvvatlash xizmatiga yozing — yordam beramiz.",
  'claim.error': "Amalni bajarib bo'lmadi. Qaytadan urinib ko'ring.",
  'claim.retry': 'Qaytadan urinish',
  'phone.title': 'Telefon qoldiring',
  'phone.subtitle':
    "Hisob bo'yicha bog'lanamiz va uzaytirishni eslatamiz. Reklama qo'ng'iroqlari bo'lmaydi.",
  'phone.label': 'Telefon',
  'phone.save': 'Saqlash',
  'phone.saving': 'Saqlanmoqda…',
  'phone.thanks': 'Rahmat — telefon saqlandi.',
  'watch.follow': 'Kompaniyani kuzatish',
  'watch.following': 'Kuzatyapsiz',
  'watch.hintWinner': 'Bu kompaniya yangi shartnoma yutganda dayjestga yuboramiz.',
  'watch.hintBuyer': 'Bu buyurtmachi yangi shartnoma joylashtirganda dayjestga yuboramiz.',
  'watch.proRequired': "Kompaniyalarni kuzatish Pro'da mavjud.",
  'watch.limitReached':
    "Chegaraga yetdingiz — 50 ta tashkilot. Yangisini qo'shish uchun bittasini kuzatishni to'xtating.",
  'watch.list.title': 'Kuzatilayotgan kompaniyalar',
  'watch.list.hint': 'Bu tashkilotlarning yangi shartnomalari va tenderlari dayjestingizga keladi.',
  'watch.list.empty':
    "Hozircha yo'q. Buyurtmachi yoki yetkazib beruvchi sahifasida «Kompaniyani kuzatish» tugmasini bosing.",
  'watch.list.unfollow': "Kuzatishni to'xtatish",
  'watch.list.kindBuyer': 'buyurtmachi',
  'watch.list.kindWinner': 'yetkazib beruvchi',
  'saved.categoriesLabel': 'Obuna toifalari',
  // Trigger for the shared picker — adds a category, an IKPU code OR a niche.
  'saved.categoryAdd': "Toifa, YeNKT yoki yo'nalish qo'shish",
  'saved.categoryRemove': 'Toifani olib tashlash',
  'saved.ikpuLabel': 'Obuna YeNKT kodlari',
  'saved.ikpuRemove': 'YeNKT kodini olib tashlash',
  'saved.nicheLabel': "Obuna yo'nalishlari",
  'saved.nicheRemove': "Yo'nalishni olib tashlash",
  'saved.regionLabel': 'Hududlar',
  'saved.kindLabel': 'Xarid turi',
  'saved.textLabel': "Tavsifdagi so'zlar",
  'saved.textPlaceholder': 'nasos',
  'saved.textHint': "Shu so'zlardan bittasi yetarli.",
  'saved.anyRegion': 'Barcha hududlar',
  'saved.includeSupplyLabel': "Ta'minot so'rovlarini ham yuborish",
  'saved.includeSupplyHint': "cooperation.uz'dagi byudjetsiz so'rovlar, shu filtr bo'yicha.",
  'saved.customerLabel': 'Buyurtmachi',
  'saved.customerPlaceholder': 'Tashkilot nomi',
  'saved.customerHint': "Bildirishnomalar faqat shu buyurtmachining tenderlari bo'yicha keladi.",
  'saved.customerRemove': 'Buyurtmachini olib tashlash',

  // ── AI onboarding (v1, 2026-09-24) ───────────────────────────────
  'aiOnboarding.step1.title': 'Nima yetkazib berasiz?',
  'aiOnboarding.step1.desc':
    "O'z so'zlaringiz bilan yozing. Kodlar, nishalar va bildirishnoma so'zlarini tanlab beramiz.",
  'aiOnboarding.step1.placeholder': 'nasoslar va ularga ehtiyot qismlar, elektrodvigatellar',
  'aiOnboarding.step1.example': 'Masalan: nasoslar va ularga ehtiyot qismlar, elektrodvigatellar.',
  'aiOnboarding.step1.submit': 'Tanlab berish',
  'aiOnboarding.step1.loading': 'Tanlanmoqda…',
  'aiOnboarding.step1.manual': "toifani qo'lda tanlash",
  // Never shown on Uzbekistan (the tiles-first screen runs on KZ only); kept for key parity.
  'aiOnboarding.tiles.title': 'Nima yetkazib berasiz?',
  'aiOnboarding.tiles.desc': 'Sohangizni tanlang',
  'aiOnboarding.tiles.aiTitle': "Yoki o'z so'zlaringiz bilan yozing",
  'aiOnboarding.tiles.aiCaption': "AI siz uchun kodlar va so'zlarni tanlaydi",
  'aiOnboarding.tiles.orTap': 'yoki yuqoridan sohangizni bosing',
  'aiOnboarding.quota.counter': '{{limit}} tadan {{left}} ta AI-qidiruv',
  'aiOnboarding.quota.left': "Yana {{n}} {{word}} qoldi. Pro'da — oyiga 15 ta.",
  'aiOnboarding.quota.word.one': 'AI-qidiruv',
  'aiOnboarding.quota.word.few': 'AI-qidiruv',
  'aiOnboarding.quota.word.many': 'AI-qidiruv',
  'aiOnboarding.step2.title': 'Nima chiqqanini tekshiring',
  'aiOnboarding.step2.byAi': "Tavsif bo'yicha AI tanladi — kodlarni tekshiring.",
  'aiOnboarding.row.categories': 'Toifalar',
  'aiOnboarding.row.subject': 'Toifalar, IKPU va nishalar',
  'aiOnboarding.row.ikpu': 'IKPU kodlari',
  'aiOnboarding.row.niches': 'Nishalar',
  'aiOnboarding.row.keywords': "So'zlar ru + uz",
  'aiOnboarding.row.regions': 'Hududlar',
  'aiOnboarding.row.excludes': 'Istisno qilish',
  'aiOnboarding.counts': 'Hozir {{open}} ta ochiq lot · kuniga {{perDay}} ta yangi',
  'aiOnboarding.locked': 'yana {{n}} {{word}} — Pro tarifida',
  'aiOnboarding.code.one': 'kod',
  'aiOnboarding.code.few': 'kod',
  'aiOnboarding.code.many': 'kod',
  'aiOnboarding.save': 'Saqlash va bildirishnoma olish',
  'aiOnboarding.saving': 'Saqlanmoqda…',
  'aiOnboarding.saveError': "Qidiruvni saqlab bo'lmadi. Yana urinib ko'ring.",
  'aiOnboarding.edit': "O'zgartirish",
  'aiOnboarding.chipRemove': 'Olib tashlash: {{label}}',
  'aiOnboarding.chipAdd': "Qo'shish: {{label}}",
  'aiOnboarding.addWord': "qo'shish",
  'aiOnboarding.aiMark': "AI to'ldirgan",
  'aiOnboarding.notUnderstood.title': 'Tavsifni tushunmadim',
  'aiOnboarding.notUnderstood.desc':
    "Nima yetkazib berishingizni aniqroq yozing — masalan «nasoslar va ularga ehtiyot qismlar». Yoki toifani qo'lda tanlang.",
  'aiOnboarding.notUnderstood.refine': 'Aniqlashtirish',
  'aiOnboarding.notUnderstood.manual': 'Toifani tanlash',
  'aiOnboarding.broad.title': 'Juda keng: {{n}} ta ochiq lot',
  'aiOnboarding.broad.desc':
    "Bildirishnomalarga deyarli butun katalog tushadi. So'z yoki hudud qo'shing — aniqroq bo'ladi.",
  'aiOnboarding.broad.narrow': 'Toraytirish',
  'aiOnboarding.broad.keep': 'shundayligicha qoldirish',
  'aiOnboarding.broad.budgetChip': '{{amount}} dan',
  'aiOnboarding.none.title': "Hozir mos lotlar yo'q",
  'aiOnboarding.none.desc':
    "Qidiruvni saqlaymiz va birinchi lot chiqishi bilan bildirishnoma yuboramiz. Bunday so'rovlar bo'yicha bu odatda oyiga 1–2 marta.",
  'aiOnboarding.none.save': 'Saqlash va kutish',
  'aiOnboarding.none.widen': 'Kengaytirish',
  'aiOnboarding.widened.title': 'Lotlar kelishi uchun tanlov kengaytirildi',
  'aiOnboarding.widened.desc': "Aniq so'rov bo'yicha hozir ochiq lotlar: {{n}}. Nima o'zgardi:",
  'aiOnboarding.widened.class':
    "kodlar — sinfgacha (dastlabki 6 raqam): shu tovarning qo'shni pozitsiyalari ham keladi",
  'aiOnboarding.widened.category':
    "kategoriya qo'shildi — undagi tanlov so'zlari bor lotlar keladi",
  'aiOnboarding.widened.budget': 'byudjetning quyi chegarasisiz',
  'aiOnboarding.widened.regions': "butun mamlakat bo'yicha, hududsiz",
  'aiOnboarding.widened.restore': 'Qaytarish:',
  'aiOnboarding.quotaOut.title': 'AI-qidiruvlar tugadi',
  'aiOnboarding.quotaOut.desc':
    "Ikkita bepul tanlov ishlatildi. Qidiruvni qo'lda yig'ish mumkin — yoki Pro oching, u yerda oyiga 15 ta tanlov bor.",
  'aiOnboarding.quotaOut.descMonth':
    "Bu oyga ajratilgan tanlovlar ishlatildi. Qidiruvni qo'lda yig'ish mumkin — yangilari oy boshida paydo bo'ladi.",
  'aiOnboarding.quotaOut.manual': "Qo'lda yig'ish",
  'aiOnboarding.quotaOut.pro': 'Pro ochish',
  'aiOnboarding.error.title': 'AI javob bermadi',
  'aiOnboarding.error.desc':
    'Model odatdagidan uzoq jim yoki xato qaytardi — oddiy toifa tanlashni ochamiz, urinish hisoblanmaydi.',
  'aiOnboarding.error.manual': 'Toifani tanlash',
  'aiOnboarding.error.retry': 'Qayta urinish',
  'aiOnboarding.manualFooter': "Toifani qo'lda tanlash har doim ochiq — AI yagona yo'l emas.",
  'aiOnboarding.fill.title': "Nima kerakligini yozing — AI maydonlarni to'ldiradi",
  'aiOnboarding.fill.placeholder':
    'nasoslar va elektrodvigatellar kerak, Toshkent va viloyat, 20 mln dan',
  'aiOnboarding.fill.submit': "AI bilan to'ldirish",
  'aiOnboarding.fill.filled': "AI to'ldirdi — odatdagidek o'zgartirsa bo'ladi",
  // ── Readiness checklist (per-tender, cluster 3, 2026-08-18) ─────
  // ── «Kompyuterda to'lash» (XDEV-LINK, 2026-09-26) ────────────────
  'plans.payFromDesktop': "Kompyuterda to'lash",
  'plans.payFromDesktopSending': 'Havola yuborilmoqda…',
  'plans.payLinkSentTelegram': 'Havola Telegramga yuborildi, 24 soat amal qiladi',
  'plans.payLinkSentEmail': 'Havola pochtaga yuborildi, 24 soat amal qiladi',
  'plans.payLinkNoChannel': "Havolani yuborish uchun manzil yo'q — profilda pochtani qo'shing",
  'plans.payLinkNoChannelCta': "Pochta qo'shish",
  'plans.payLinkError': "Havolani yuborib bo'lmadi. Qaytadan urinib ko'ring",
  // «Telefon orqali to'lov» — SMS-hisob (2026-09-27)
  'plans.sms.hint':
    "{{app}} brauzerida karta bilan to'lov o'tmaydi. Raqamingizga «FASTAGO» MChJ nomidan hisob yuboramiz — uni {{apps}} ilovasida bir daqiqada to'laysiz",
  'plans.sms.or': ' yoki ',
  'plans.sms.phoneLabel': 'Telefon raqami',
  'plans.sms.pickGateway': "Qaysi ilovada to'laysiz",
  'plans.sms.send': 'Raqamimga hisob yuborish',
  'plans.sms.sending': 'Hisob yuborilmoqda…',
  'plans.sms.sentTitle': '✓ Hisob {{phone}} raqamiga yuborildi',
  'plans.sms.sentBody':
    "{{gateway}} ilovasini oching — u yerda «FASTAGO» MChJ dan to'lov uchun hisob bor. Kirish avtomatik ochiladi, sahifani yopishingiz mumkin",
  'plans.sms.sentPaymeSms': "Payme to'lov havolasini SMS orqali ham yuboradi.",
  'plans.sms.waiting': "To'lovni kutyapmiz…",
  'plans.sms.resendPrompt': 'Hisob 2 daqiqada kelmadimi?',
  'plans.sms.resend': 'Qayta yuborish',
  'plans.sms.resendIn': '{{time}} dan keyin qayta yuborish',
  'plans.sms.switchGateway': "{{gateway}} orqali to'lash",
  'plans.sms.paidTitle': "To'landi — {{name}} faol",
  'plans.sms.goTenders': "Tenderlarga o'tish",
  'plans.sms.fallbackHosted': "Click yoki Payme sahifasida to'lash",
  'plans.sms.seconds': '{{n}} soniya',
  'plans.sms.minutes': '{{n}} daqiqa',
  'plans.sms.hours': '{{n}} soat',
  'plans.sms.err.invalid_phone': 'Raqamni kiriting: +998 va 9 ta raqam',
  'plans.sms.err.no_gateway_account':
    "Bu raqam {{gateway}}da ro'yxatdan o'tmagan. Boshqa ilova yoki raqamni tanlang",
  'plans.sms.err.gateway_declined':
    "{{gateway}} so'rovni qabul qilmadi. Boshqa ilovani sinab ko'ring",
  'plans.sms.err.provider_unavailable': '{{gateway}} hozir ishlamayapti. Boshqa ilovani tanlang',
  'plans.sms.err.rate_limited': "So'rovlar juda ko'p. {{time}} dan keyin urinib ko'ring",
  'plans.sms.err.gateway_error': "{{gateway}} javob bermadi. Qayta urinib ko'ring",
  'plans.sms.err.generic': "Hisob yuborib bo'lmadi. Qayta urinib ko'ring",

  // ── /pay/:token sahifasi ─────────────────────────────────────────
  'payLink.pageTitle': "To'lov",
  'payLink.loading': "To'lovni ochyapmiz…",
  'payLink.title': "Kompyuterda to'lash",
  'payLink.lead': "Buyurtma tayyor — to'lov sahifasiga o'tish uchun tugmani bosing.",
  'payLink.cta': "To'lovga o'tish",
  'payLink.onceNote': "Havola bir marta ochiladi. To'lov sahifasi shu oynada ochiladi.",
  'payLink.backToPlans': 'Tariflarga qaytish',
  'payLink.openPlans': 'Tariflarni ochish',
  'payLink.used.title': 'Havola allaqachon ochilgan',
  'payLink.used.body':
    "U faqat bir marta ishlaydi. Agar to'lov o'tmagan bo'lsa, tariflarni oching va qaytadan boshlang — pul yechilmagan.",
  'payLink.notFound.title': 'Havola ishlamaydi',
  'payLink.notFound.body':
    "Amal qilish muddati — 24 soat. Buyurtma allaqachon to'langan yoki bekor qilingan bo'lishi mumkin. Tariflarni oching va qaytadan boshlang.",
  // ── Sessiyasiz kompyuterda chek (/billing/return?pl=<token>) ─────
  'payLink.receipt.paidTitle': "To'lov o'tdi",
  'payLink.receipt.paidBody': 'Kirish ochildi. Ishni boshlash uchun akkauntga kiring.',
  'payLink.receipt.pendingTitle': "To'lov tasdig'ini kutyapmiz",
  'payLink.receipt.pendingBody':
    "To'lovni bank hali tasdiqlamoqda. Bir daqiqadan keyin sahifani yangilang — yoki shunchaki akkauntga kiring, kirish o'zi ochiladi.",
  'payLink.receipt.failedTitle': "To'lov o'tmadi",
  'payLink.receipt.failedBody': "Pul yechilmadi. Qaytadan urinib ko'rish mumkin.",
  'payLink.receipt.paidAt': "{{date}} to'landi",
  'payLink.receipt.loginTelegram': 'Siz Telegram orqali kirgan edingiz {{hint}}',
  'payLink.receipt.loginTelegramPlain': 'Siz Telegram orqali kirgan edingiz',
  'payLink.receipt.loginEmail': 'Siz pochta orqali kirgan edingiz {{hint}}',
  'payLink.receipt.loginEmailPlain': 'Siz pochta orqali kirgan edingiz',
  'payLink.receipt.login': 'Akkauntga kirish',
  // ── /zayavka — Meta Lead kampaniyasi uchun ariza shakli (2026-10-06, v2) ──
  'zayavka.pageTitle': 'Ariza: mahsulotingizga mos tenderlarni topamiz',
  'zayavka.metaDescription':
    "Uch qadamda sohangiz bo'yicha ochiq davlat xaridlarini saralab beramiz.",
  'zayavka.progress': '{{n}} / {{total}}',
  'zayavka.back': '← Orqaga',
  'zayavka.next': 'Keyingisi',
  'zayavka.s1.title': 'Nima yetkazib berasiz?',
  'zayavka.s1.search': 'Mahsulot, xizmat yoki YeNKT kodi',
  'zayavka.s1.keyword': "«{{q}}» bo'yicha qidirish",
  'zayavka.s1.loading': 'Ochiq lotlarni sanayapmiz…',
  'zayavka.s1.summary': '{{count}} {{lots}}, jami {{sum}} {{currency}}',
  'zayavka.s1.summaryNoSum': '{{count}} {{lots}}',
  'zayavka.s1.none': "Hozircha ochiq lot yo'q",
  'zayavka.lots.one': 'ta ochiq lot',
  'zayavka.lots.few': 'ta ochiq lot',
  'zayavka.lots.many': 'ta ochiq lot',
  'zayavka.lot.until': '{{date}}-gacha',
  'zayavka.lot.noBudget': "Byudjet ko'rsatilmagan",
  'zayavka.lot.announced': 'Tez orada arizalar qabul qilinadi',
  'zayavka.s2.title': 'Siz haqingizda',
  'zayavka.q.experience': 'Tenderlarda qatnashganmisiz?',
  'zayavka.q.experience.won_this_year': "Shu yili g'olib bo'lganman",
  'zayavka.q.experience.won_last_year': "O'tgan yili g'olib bo'lganman",
  'zayavka.q.experience.participated': 'Qatnashganman, yutmaganman',
  'zayavka.q.experience.never': 'Qatnashmaganman',
  'zayavka.q.esign': 'Elektron raqamli imzo (ERI) bormi?',
  'zayavka.q.esign.yes': 'Ha',
  'zayavka.q.esign.no': "Yo'q",
  'zayavka.q.form': 'Kompaniya shakli',
  'zayavka.q.form.legal': 'Yuridik shaxs (MChJ, AJ…)',
  'zayavka.q.form.ip': 'YaTT',
  'zayavka.q.form.self_employed': "O'zini o'zi band qilgan",
  'zayavka.q.form.individual': 'Jismoniy shaxs',
  'zayavka.q.budget': 'Qaysi tender byudjeti sizga mos?',
  'zayavka.q.budget.lt_100m': '100 mln-gacha',
  'zayavka.q.budget.100m_1b': '100 mln – 1 mlrd',
  'zayavka.q.budget.1b_10b': '1–10 mlrd',
  'zayavka.q.budget.gt_10b': "10 mlrd so'mdan ortiq",
  'zayavka.s3.title': "Siz bilan qanday bog'lanamiz",
  'zayavka.id.label': 'STIR yoki JShShIR',
  'zayavka.id.invalid': 'STIR — 9 ta raqam, JShShIR — 14 ta',
  'zayavka.phone.label': 'Telefon',
  'zayavka.phone.country': 'Mamlakat kodi',
  'zayavka.phone.invalid': 'Raqamni tekshiring',
  'zayavka.submit': 'Yuborish',
  'zayavka.submitting': 'Yuborilmoqda…',
  'zayavka.consent': "Tugmani bosib, qo'ng'iroq yoki Telegramda xabar olishga rozilik bildirasiz",
  'zayavka.error.network': "Aloqa yo'q — yana bosing",
  'zayavka.error.rateLimited': "Bu tarmoqdan arizalar juda ko'p. Bizga yozing:",
  'zayavka.error.generic': "Yuborib bo'lmadi. Bizga yozing:",
  'zayavka.thanks.title': 'Arizangiz uchun rahmat',
  'zayavka.thanks.body':
    "Profilingizni ko'rib chiqib, siz bilan bog'lanamiz — odatda bir ish kuni ichida",
  'zayavka.thanks.register': "Bepul ro'yxatdan o'tish",
} as const;

export type UzKeys = keyof typeof uz;
